export const esES = {
  translation: {
    // Common
    common: {
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      add: "Añadir",
      search: "Buscar",
      loading: "Cargando...",
      confirm: "Confirmar",
      back: "Volver",
      next: "Siguiente",
      close: "Cerrar",
      yes: "Sí",
      no: "No",
      all: "Todos",
      none: "Ninguno",
      actions: "Acciones",
      view: "Ver",
      export: "Exportar",
      import: "Importar",
      filter: "Filtrar",
      clear: "Limpiar",
      apply: "Aplicar",
      today: "Hoy",
      yesterday: "Ayer",
      tomorrow: "Mañana",
      week: "Semana",
      month: "Mes",
      year: "Año",
      or: "o",
      and: "y",
      of: "de",
      to: "hasta",
      from: "desde",
      active: "Activo",
      inactive: "Inactivo",
      enabled: "Activado",
      disabled: "Desactivado",
      blocked: "Bloqueado",
      new: "Nuevo",
      create: "Crear",
      update: "Actualizar",
      refresh: "Actualizar",
      details: "Detalles",
      status: "Estado",
      name: "Nombre",
      email: "Correo electrónico",
      phone: "Teléfono",
      address: "Dirección",
      date: "Fecha",
      time: "Hora",
      value: "Valor",
      total: "Total",
      quantity: "Cantidad",
      price: "Precio",
      description: "Descripción",
      notes: "Notas",
      select: "Seleccionar",
      selected: "Seleccionado",
      confirmed: "confirmados",
      pending: "Pendiente",
      completed: "Completado",
      conversion: "conversión",
      optional: "opcional",
      see_all: "Ver todos",
      see_all_feminine: "Ver todas",
      no_data: "Sin datos",
      income: "Ingreso",
      expense: "Gasto",
      register_transaction: "Registrar transacción",
      more: "más",
      system: "Sistema",
      user: "Usuario",
      discount: "de descuento",
      min: "Mín.",
      until: "Hasta",
      color: "Color",
      preview: "Vista Previa",
      saving: "Guardando...",
      tags: "Etiquetas",
      copy: "Copiar",
      error: "Error",
      business: "Negocio",
      other: "Otros",
      type: "Tipo",
      hello: "Hola",
    },

    // Projects Module
    projects_module: {
      title: "Proyectos",
      subtitle: "Gestiona tus proyectos y tareas",
      new_project: "Nuevo Proyecto",
      edit_project: "Editar Proyecto",
      create_project: "Crear Proyecto",
      delete_project: "Eliminar Proyecto",
      confirm_delete: "¿Estás seguro de que deseas eliminar este proyecto? Todas las tareas asociadas también serán eliminadas.",
      no_projects: "Ningún proyecto encontrado",
      create_first_project: "Crea tu primer proyecto para organizar tus tareas",
      loading_projects: "Cargando proyectos...",
      active_projects: "Proyectos Activos",
      completed: "Completados",
      start_date: "Fecha de Inicio",
      end_date: "Fecha de Fin",
      priority: "Prioridad",
      deadline: "Plazo",
      status: {
        active: "Activo",
        completed: "Completado",
        cancelled: "Cancelado",
      },
    },

    // Tickets
    tickets: {
      title: "Tickets",
      subtitle: "Gestiona solicitudes y problemas internos",
      new_ticket: "Nuevo Ticket",
      open_ticket: "Abrir Ticket",
      ticket_title: "Título",
      title_placeholder: "Describe brevemente el problema",
      description_placeholder: "Detalles del problema...",
      category: "Categoría",
      priority: "Prioridad",
      open: "Abiertos",
      in_progress: "En progreso",
      resolved: "Resueltos",
      search_placeholder: "Buscar tickets...",
      filter_by_status: "Filtrar por estado",
      all_statuses: "Todos los estados",
      no_tickets: "No se encontraron tickets",
      try_filters: "Intenta cambiar los filtros",
      open_first_ticket: "Abre un ticket para registrar problemas o solicitudes",
      no_description: "Sin descripción",
      comments: "Comentarios",
      no_comments: "Sin comentarios",
      add_comment_placeholder: "Agregar comentario...",
      support: "Soporte",
      you: "Tú",
    },

    // Notifications
    notifications: {
      title: "Notificaciones",
      mark_all_read: "Marcar todas como leídas",
      no_notifications: "Sin notificaciones",
    },

    // Projects
    projects: {
      subtasks: "Subtareas",
      subtask_title: "Título de la subtarea",
      no_subtasks: "Sin subtareas",
      delete_subtask: "Eliminar Subtarea",
      delete_subtask_confirm: "¿Estás seguro de que deseas eliminar esta subtarea?",
    },

    // Units
    units: {
      members: "Miembros",
      select_user: "Selecciona el usuario",
      choose_user: "Elige un usuario...",
      no_name: "Sin nombre",
      unit_role: "Rol en la unidad",
      admin_full_access: "Administrador (acceso total)",
      manager_edit: "Gerente (editar datos)",
      staff_operations: "Empleado (operaciones)",
      viewer_readonly: "Visualizador (solo lectura)",
      all_users_members: "Todos los usuarios ya son miembros",
      add_member: "Agregar Miembro",
      current_members: "Miembros actuales",
      no_members: "Sin miembros agregados",
      add_users_access: "Agrega usuarios para dar acceso a esta unidad",
      remove_member_confirm: "¿Eliminar este miembro de la unidad?",
      role_admin: "Administrador",
      role_manager: "Gerente",
      role_staff: "Empleado",
      role_viewer: "Visualizador",
      manager: "Gerente",
      staff: "Empleado",
      viewer: "Visualizador",
    },

    // Reminders Module
    reminders: {
      title: "Recordatorios",
      subtitle: "Crea recordatorios para enviar por WhatsApp, Email o Notificación",
      new_reminder: "Nuevo Recordatorio",
      create_reminder: "Crear Recordatorio",
      reminder_title: "Título",
      title_placeholder: "Recordar...",
      description_optional: "Descripción (opcional)",
      description_placeholder: "Detalles del recordatorio...",
      datetime: "Fecha/Hora",
      notification_type: "Tipo de Notificación",
      system_notification: "Notificación del Sistema",
      whatsapp_phone: "Teléfono (WhatsApp)",
      phone_placeholder: "+34 612 345 678",
      email_address: "Email",
      email_placeholder: "email@ejemplo.com",
      pending: "Pendientes",
      sent: "Enviados",
      all: "Todos",
      no_pending: "No hay recordatorios pendientes",
      no_sent: "No hay recordatorios enviados",
      no_created: "No hay recordatorios creados",
      delete_reminder: "Eliminar Recordatorio",
      delete_confirm: "¿Estás seguro de que deseas eliminar este recordatorio?",
      send: "Enviar",
      sent_badge: "Enviado",
      whatsapp_sent: "¡Recordatorio enviado por WhatsApp!",
      email_sent: "¡Recordatorio enviado por Email!",
      send_error: "Error al enviar recordatorio: ",
      no_whatsapp_instance: "No hay instancia de WhatsApp conectada",
      notification_label: "Notificación",
    },

    // Files Module
    files: {
      title: "Archivos",
      subtitle: "Gestiona tus archivos y carpetas",
      new_folder: "Nueva Carpeta",
      upload_file: "Subir Archivo",
      folder_name: "Nombre de la Carpeta",
      folder_name_placeholder: "Nombre de la carpeta",
      no_files: "Sin archivos",
      no_files_desc: "Sube archivos o crea carpetas para organizar",
      delete_file: "Eliminar Archivo",
      delete_file_confirm: "¿Estás seguro de que deseas eliminar este archivo? Esta acción no se puede deshacer.",
      delete_folder: "Eliminar Carpeta",
      delete_folder_confirm: "¿Estás seguro de que deseas eliminar esta carpeta? Esta acción no se puede deshacer.",
      download: "Descargar",
      preview: "Vista Previa",
      all_files: "Todos los Archivos",
      images: "Imágenes",
      videos: "Videos",
      documents: "Documentos",
      searching: "Buscando...",
      select_folder: "Selecciona una carpeta",
      root: "Raíz",
    },

    // Chatbot Module
    chatbot_module: {
      conversations: "Conversaciones",
      search_conversations: "Buscar conversaciones...",
      no_conversations: "No se encontraron conversaciones",
      unknown: "Desconocido",
      contact: "Contacto",
      human_control: "Control Humano",
      configure: "Configurar",
      stats: "Estadísticas",
      active: "Activas",
      waiting: "Esperando",
      closed: "Cerradas",
      take_over: "Tomar Control",
      release: "Liberar",
      close_conversation: "Cerrar",
      create_lead: "Crear Lead",
      manage_tags: "Gestionar Etiquetas",
      no_messages: "Sin mensajes aún",
      start_conversation: "Inicia la conversación enviando un mensaje",
      select_conversation: "Selecciona una conversación",
      select_conversation_desc: "Elige una conversación a la izquierda para ver",
      you: "Tú",
      bot: "Bot",
    },
    
    // Navigation
    nav: {
      dashboard: "Panel",
      agenda: "Agenda",
      clients: "Clientes",
      products: "Productos",
      services: "Servicios",
      finance: "Finanzas",
      marketing: "Marketing",
      reports: "Informes",
      settings: "Configuración",
      help: "Ayuda",
      logout: "Salir",
      pos: "TPV",
      tickets: "Tickets",
      chatbot: "Chatbot IA",
      catalog: "Catálogo",
      module_store: "Tienda de Módulos",
      ai_assistant: "Asistente IA",
      
      // Navigation groups
      groups: {
        main: "Principal",
        sales: "Ventas",
        operations: "Operaciones",
        marketing: "Marketing",
        management: "Gestión",
        intelligence: "Inteligencia",
        team: "Equipo",
        online_presence: "Presencia Online",
        integrations: "Integraciones",
      },
      
      // Navigation items - keys must match NavigationConfig.tsx nameKey values
      items: {
        dashboard: "Panel",
        moduleStore: "Tienda de Módulos",
        agenda: "Agenda",
        pos: "TPV",
        clients: "Clientes",
        chatbotAI: "Chatbot IA",
        aiAssistant: "Asistente IA",
        crm: "CRM",
        quotes: "Presupuestos",
        contracts: "Contratos",
        subscriptions: "Suscripciones",
        clientPlans: "Planes de Clientes",
        packages: "Paquetes",
        catalog: "Catálogo",
        delivery: "Entregas",
        ecommerce: "E-commerce",
        projects: "Proyectos",
        reminders: "Recordatorios",
        inventory: "Inventario",
        checklists: "Checklists",
        tickets: "Tickets",
        passwordPanel: "Panel de Contraseñas",
        resourceBooking: "Reserva de Recursos",
        fiscalNotes: "Fiscal y Facturas",
        medicalRecords: "Historial Médico",
        workouts: "Entrenamientos",
        realEstate: "Inmobiliaria",
        campaigns: "Campañas",
        whatsappGroups: "Grupos de WhatsApp",
        automations: "Automatizaciones",
        loyalty: "Fidelización",
        nps: "NPS",
        satisfaction: "Satisfacción",
        reviews: "Reseñas",
        referrals: "Referencias",
        reactivation: "Reactivación",
        financial: "Finanzas",
        commissions: "Comisiones",
        goals: "Metas",
        reports: "Informes",
        aiPro: "IA Pro",
        leadHunter: "Lead Hunter",
        funnelAnalytics: "Analytics de Embudo",
        aiCompetitors: "IA Competidores",
        aiPricing: "IA Precios",
        aiInsights: "Insights IA",
        aiCopy: "IA Copy",
        communication: "Comunicación",
        learning: "Aprendizaje",
        forms: "Formularios",
        library: "Biblioteca",
        peopleManagement: "Gestión de Personas",
        myLinks: "Mis Enlaces",
        miniSite: "Mini Sitio",
        clientPortal: "Portal del Cliente",
        webhooks: "Webhooks",
        apiKeys: "API Keys",
        settings: "Configuración",
        onlinePresence: "Presencia Online",
      },
    },
    
    // Dashboard
    dashboard: {
      welcome: "¡Hola, {{name}}!",
      summary: "Aquí está el resumen de tu día.",
      summary_with_appointments: "Aquí está el resumen de tu día. Tienes {{count}} cita(s) hoy.",
      monthly_revenue: "Ingresos Mensuales",
      appointments_today: "Citas de Hoy",
      pending_tasks: "Tareas Pendientes",
      active_clients: "Clientes Activos",
      upcoming_appointments: "Próximas Citas",
      recent_transactions: "Transacciones Recientes",
      transactions: "Transacciones",
      no_appointments: "Sin citas próximas",
      create_appointment: "Crear cita",
      new_this_month: "nuevos este mes",
      this_month: "este mes",
      no_movements: "Sin transacciones recientes",
      no_movements_short: "Sin transacciones",
      see_all: "Ver todos",
      quick_actions: "Acciones Rápidas",
      alerts: "Alertas",
      vip_inactive: "VIPs inactivos por 30 días",
      pending_leads: "leads esperando acción",
      financial_overview: "Resumen Financiero",
      no_data_yet: "Sin datos aún",
      add_first_sale: "Añade tu primera venta",
      next_available_time: "Próximo horario disponible a partir de las próximas horas",
      
      // Stats
      confirmed: "confirmados",
      none: "Ninguno",
      
      // Alerts
      top_inactive_clients: "Clientes Top Inactivos",
      click_to_see_details: "Clic para ver detalles",
      pending_leads_count: "Leads Pendientes",
      click_to_see_pipeline: "Clic para ver pipeline",
      inactive_clients: "Clientes Inactivos",
      click_to_reactivate: "Clic para reactivar",
      
      // Suggestions
      automatic_suggestions: "Sugerencias Automáticas",
      reactivate_inactive: "Reactivar Clientes Inactivos",
      clients_not_buying: "clientes no compran hace más de 30 días",
      inactive_vip_clients: "Clientes VIP Inactivos",
      vip_need_attention: "clientes VIP necesitan atención",
      create_special_coupon: "Crear Cupón Especial",
      increase_engagement: "Aumenta el engagement con una oferta exclusiva",
      pending_proposals: "Propuestas Pendientes",
      opportunities_awaiting: "oportunidades esperando seguimiento",
      create_campaign: "Crear Campaña",
      send_offer: "Enviar Oferta",
      create_coupon: "Crear Cupón",
      see_pipeline: "Ver Pipeline",
      
      // Appointment status
      status: {
        confirmed: "Confirmado",
        scheduled: "Programado",
        completed: "Completado",
        cancelled: "Cancelado",
      },
      
      // Client info
      client_not_informed: "Cliente no informado",
      service_not_informed: "Servicio no informado",
    },
    
    // Quick Actions
    quick_actions: {
      title: "Acciones Rápidas",
      schedule: "Agendar",
      new_client: "Nuevo Cliente",
      register_sale: "Registrar Venta",
      send_campaign: "Enviar Campaña",
      new_appointment: "Nueva Cita",
      client: "Cliente",
      service: "Servicio",
      professional: "Profesional",
      date_time: "Fecha y Hora",
      select_client: "Seleccionar cliente",
      select_service: "Seleccionar servicio",
      select_professional: "Seleccionar profesional",
      client_name: "Nombre del cliente",
      sale_description: "Descripción de la venta",
      register: "Registrar",
      create: "Crear",
      fill_required: "Complete todos los campos obligatorios",
      name_required: "El nombre es obligatorio",
      fill_value_description: "Complete valor y descripción",
      appointment_created: "¡Cita creada con éxito!",
      appointment_error: "Error al crear cita",
      client_created: "¡Cliente registrado con éxito!",
      client_error: "Error al registrar cliente",
      sale_created: "¡Venta registrada con éxito!",
      sale_error: "Error al registrar venta",
    },
    
    // Agenda
    agenda: {
      title: "Agenda",
      subtitle: "Gestiona tus citas",
      new_appointment: "Nueva Cita",
      select_client: "Seleccionar cliente",
      select_service: "Seleccionar servicio",
      select_professional: "Seleccionar profesional",
      select_time: "Seleccionar hora",
      notes: "Notas",
      day: "Día",
      week: "Semana",
      calendar: "Calendario",
      online_booking: "Reserva Online",
      waiting_list: "Lista de Espera",
      widget: "Widget",
      settings: "Configuración",
      filter_by_professional: "Filtrar por profesional",
      all_professionals: "Todos",
      no_appointments_day: "Sin citas en este día",
      quick_customer: "Registro Rápido",
      continue_booking: "Continuar con la reserva",
      customer_name_required: "El nombre del cliente es obligatorio",
      customer_registered: "¡Cliente registrado! Ahora continúa con la reserva.",
      fill_required: "Completa todos los campos obligatorios",
      appointment_created: "¡Cita creada con éxito!",
      select_professional_confirm: "Por favor selecciona un profesional",
      appointment_details: "Detalles de la Cita",
      send_confirmation: "Enviar Confirmación",
      confirmation_sent: "¡Mensaje de confirmación enviado a {{name}}!",
      reschedule: "Reprogramar",
      cancel_appointment: "Cancelar Cita",
      cancel_confirm: "¿Estás seguro de que deseas cancelar esta cita?",
      cancel_irreversible: "Esta acción no se puede deshacer.",
      keep: "Mantener",
      confirm_cancel: "Sí, cancelar",
      cancelled_success: "¡Cita cancelada!",
      cancellation_sent: "¡Mensaje de cancelación enviado a {{name}}!",
      reschedule_appointment: "Reprogramar Cita",
      new_date: "Nueva Fecha",
      new_time: "Nueva Hora",
      confirm_reschedule: "Confirmar Reprogramación",
      rescheduled_success: "¡Cita reprogramada!",
      reschedule_sent: "¡Mensaje de reprogramación enviado a {{name}}!",
      complete_appointment: "Completar Cita",
      use_loyalty_points: "Usar puntos de fidelización",
      available_points: "{{points}} puntos disponibles",
      use_cashback: "Usar cashback",
      available_cashback: "{{amount}} disponible",
      confirm_complete: "Confirmar y Completar",
      loyalty_redeemed: "¡Fidelización canjeada!",
      points_used: "{{points}} puntos utilizados",
      cashback_used: "{{amount}} de cashback utilizado",
      meeting_result: "Resultado de la Reunión",
      select_outcome: "Seleccionar resultado",
      outcome_contact: "Contacto realizado",
      outcome_proposal: "Propuesta enviada",
      outcome_negotiation: "En negociación",
      outcome_closed_won: "Cerrado - Ganado",
      outcome_closed_lost: "Cerrado - Perdido",
      update_deal: "Actualizar Negocio",
      deal_updated: "¡Estado del negocio actualizado!",
      copy_link: "Copiar Enlace",
      link_copied: "¡Enlace copiado!",
      open_meet: "Abrir Meet",
      status: {
        scheduled: "Programado",
        confirmed: "Confirmado",
        completed: "Completado",
        cancelled: "Cancelado",
        no_show: "No asistió",
      },
      status_updated: "Estado actualizado a {{status}}",
      package_warning: "Aviso de Paquete",
      understood: "Entendido",
      weekdays: {
        sun: "Dom",
        mon: "Lun",
        tue: "Mar",
        wed: "Mié",
        thu: "Jue",
        fri: "Vie",
        sat: "Sáb",
      },
    },
    
    // Clients
    clients: {
      title: "Clientes",
      subtitle: "Gestiona tus clientes y etiquetas",
      new_client: "Nuevo Cliente",
      edit_client: "Editar Cliente",
      update_client_desc: "Actualiza los datos del cliente",
      new_client_desc: "Completa los datos para registrar un nuevo cliente",
      total: "Total de Clientes",
      new_this_month: "Nuevos este mes",
      average_ticket: "Ticket Promedio",
      return_rate: "Tasa de Retorno",
      name: "Nombre",
      name_placeholder: "Nombre completo",
      email: "Correo electrónico",
      phone: "Teléfono",
      birthday: "Fecha de Nacimiento",
      notes: "Notas",
      notes_placeholder: "Notas sobre el cliente",
      tags: "Etiquetas",
      tags_tab: "Etiquetas",
      last_visit: "Última visita",
      total_spent: "Total gastado",
      visits: "visitas",
      search_placeholder: "Buscar por nombre, correo o teléfono...",
      all_tags: "Todas",
      no_clients: "Ningún cliente encontrado",
      try_different_search: "Intenta una búsqueda diferente",
      register_first_client: "Registra tu primer cliente para comenzar",
      client: "Cliente",
      contact: "Contacto",
      loyalty: "Fidelización",
      cpf_cnpj: "NIF/CIF",
      cpf_cnpj_placeholder: "000.000.000-00 o 00.000.000/0000-00",
      lookup_cnpj: "Buscar NIF",
      lookup_cnpj_auto: "Haz clic en el icono para buscar datos del NIF automáticamente",
      cpf_cnpj_hint: "Introduce NIF (11 dígitos) o CIF (14 dígitos)",
      invalid_cpf: "NIF inválido",
      invalid_cnpj: "CIF inválido",
      cpf_cnpj_length_error: "NIF debe tener 11 dígitos o CIF debe tener 14 dígitos",
      enter_valid_cnpj: "Introduce un CIF válido (14 dígitos) para consultar",
      select_tags: "Selecciona las etiquetas",
      no_tags_created: "Ninguna etiqueta creada. Crea etiquetas en la pestaña \"Etiquetas\".",
      name_required: "El nombre es obligatorio",
      client_updated: "¡Cliente actualizado con éxito!",
      client_created: "¡Cliente registrado con éxito!",
      confirm_delete: "Eliminar cliente",
      confirm_delete_message: "¿Estás seguro de que quieres eliminar a {{name}}? Esta acción no se puede deshacer.",
      client_deleted: "¡Cliente eliminado con éxito!",
      clients_deleted: "{{count}} cliente(s) eliminado(s)",
      send_whatsapp: "Enviar WhatsApp",
      no_phone: "El cliente no tiene teléfono registrado.",
      no_whatsapp_instance: "Ninguna instancia de WhatsApp conectada. Configura en Configuración > Integraciones.",
      enter_message: "Introduce un mensaje.",
      message_sent: "¡Mensaje enviado a {{name}}!",
      error_sending: "Error al enviar mensaje.",
      view_profile: "Ver Perfil",
      view_details: "Ver detalles",
      loyalty_points: "Puntos",
      cashback: "Cashback",
      history: "Historial",
      appointments: "Citas",
      transactions: "Transacciones",
    },
    
    // Finance
    finance: {
      title: "Finanzas",
      subtitle: "Vista general de tu flujo de caja",
      income: "Ingresos",
      income_month: "Ingresos (mes)",
      expenses: "Gastos",
      expenses_month: "Gastos (mes)",
      balance: "Balance",
      new_transaction: "Nueva Transacción",
      edit_transaction: "Editar Transacción",
      type: "Tipo",
      amount: "Monto",
      description: "Descripción",
      category: "Categoría",
      payment_method: "Método de Pago",
      date: "Fecha",
      due_date: "Fecha de Vencimiento",
      status: "Estado",
      overview: "Vista General",
      dre: "Estado de Resultados",
      forecast: "Previsión IA",
      income_vs_expenses: "Ingresos x Gastos",
      recent_transactions: "Últimas Transacciones",
      no_transactions: "Ninguna transacción encontrada",
      no_data: "Ningún dato disponible",
      view_all: "Ver todas",
      view_less: "Ver menos",
      scan_receipt: "Escanear Recibo con IA",
      create_transaction: "Crear Transacción",
      update_transaction: "Actualizar Transacción",
      confirm_delete: "Eliminar transacción",
      confirm_delete_message: "¿Estás seguro de que quieres eliminar esta transacción?",
      transaction_deleted: "¡Transacción eliminada!",
      transaction_updated: "¡Transacción actualizada!",
      payment_status: {
        paid: "Pagado",
        pending: "Pendiente",
        overdue: "Vencido",
      },
      categories: {
        service: "Servicio",
        product: "Producto",
        other: "Otros",
        supplier: "Proveedor",
        rent: "Alquiler",
        salaries: "Salarios",
        marketing: "Marketing",
        equipment: "Equipos",
      },
      payment_methods: {
        cash: "Efectivo",
        credit_card: "Tarjeta de Crédito",
        debit_card: "Tarjeta de Débito",
        pix: "PIX",
        transfer: "Transferencia",
        boleto: "Boleto",
      },
    },
    
    // Products/Inventory
    products: {
      title: "Inventario",
      subtitle: "Gestiona tus productos y movimientos",
      new_product: "Nuevo Producto",
      edit_product: "Editar Producto",
      total: "Total",
      active: "Activos",
      low_stock: "Stock Bajo",
      total_value: "Valor Total",
      low_stock_alert: "Productos con Stock Bajo",
      no_products: "Ningún producto encontrado",
      search_placeholder: "Buscar por nombre o código...",
      all_categories: "Todas las categorías",
      name: "Nombre",
      sku: "SKU",
      code: "Código",
      category: "Categoría",
      cost_price: "Precio de Costo",
      sale_price: "Precio de Venta",
      stock: "Stock",
      initial_stock: "Stock Inicial",
      min_alert: "Alerta Mínima",
      unit: "Unidad",
      description: "Descripción",
      image: "Imagen",
      visible_catalog: "Visible en Catálogo",
      create_product: "Crear Producto",
      update_product: "Actualizar Producto",
      product_created: "¡Producto creado con éxito!",
      product_updated: "¡Producto actualizado con éxito!",
      product_deleted: "¡Producto eliminado con éxito!",
      error_creating: "Error al crear producto",
      error_updating: "Error al actualizar producto",
      error_deleting: "Error al eliminar producto",
      entry: "Entrada",
      exit: "Salida",
      register_entry: "Registrar Entrada",
      register_exit: "Registrar Salida",
      movement_history: "Historial de Movimientos",
      quantity: "Cantidad",
      unit_cost: "Costo Unitario",
      movement_description: "Descripción",
      register_movement: "Registrar",
      entry_registered: "¡Entrada registrada!",
      exit_registered: "¡Salida registrada!",
      error_movement: "Error al registrar movimiento",
      no_movements: "Ningún movimiento encontrado",
      units: {
        un: "Unidad",
        ml: "Mililitro",
        g: "Gramo",
        kg: "Kilogramo",
        l: "Litro",
      },
    },
    
    // Marketing
    marketing: {
      title: "Marketing",
      subtitle: "Crea campañas y conecta con tus clientes",
      new_campaign: "Nueva Campaña",
      generate_with_ai: "Generar con IA",
      campaign_name: "Nombre de la Campaña",
      email_subject: "Asunto del Correo",
      target_audience: "Público Objetivo",
      message: "Mensaje",
      email: "Correo",
      whatsapp: "WhatsApp",
      all_clients: "Todos los clientes",
      new_clients: "Clientes nuevos (último mes)",
      birthday_month: "Cumpleaños este mes",
      inactive_clients: "Clientes inactivos (3+ meses)",
      by_tags: "Por Etiquetas",
      select_tags: "Selecciona Etiquetas",
      no_tags: "Ninguna etiqueta creada. Crea etiquetas en \"Etiquetas\".",
      templates: "Plantillas",
      use_variables: "Usa {nome} para personalización",
      save_draft: "Guardar Borrador",
      schedule: "Programar",
      send_now: "Enviar Ahora",
      all_campaigns: "Todas",
      email_campaigns: "Correo",
      whatsapp_campaigns: "WhatsApp",
      search_campaigns: "Buscar campañas...",
      filter_status: "Filtrar estado",
      all_statuses: "Todos los estados",
      status: {
        sent: "Enviado",
        sending: "Enviando...",
        scheduled: "Programado",
        draft: "Borrador",
        failed: "Fallido",
      },
      recipients: "destinatarios",
      no_email_clients: "Ningún cliente con correo en el público seleccionado",
      no_whatsapp_instance: "Ninguna instancia de WhatsApp conectada",
      configure_whatsapp: "Configura una instancia en Configuración > Integraciones",
      no_phone_clients: "Ningún cliente con teléfono en el público seleccionado",
      fill_required: "Completa los campos obligatorios",
      fill_email_subject: "Completa el asunto del correo",
      campaign_sent: "¡Campaña enviada a {{count}} cliente(s)!",
      send_error: "Error al enviar campaña",
      draft_saved: "¡Borrador guardado!",
      campaign_scheduled: "¡Campaña programada!",
      no_campaigns: "Ninguna campaña aún",
      start_first_campaign: "Empieza creando tu primera campaña",
    },
    
    // CRM
    crm: {
      title: "CRM",
      subtitle: "Pipeline de ventas y oportunidades",
      new_opportunity: "Nueva Oportunidad",
      ai_insights: "Insights IA",
      lead_scoring: "Puntuación de Leads",
      manage_stages: "Gestionar Etapas",
      opportunity_title: "Título",
      value: "Valor",
      priority: "Prioridad",
      client: "Cliente",
      expected_close: "Cierre Esperado",
      description: "Descripción",
      create_opportunity: "Crear Oportunidad",
      search_opportunities: "Buscar oportunidades...",
      filter_priority: "Filtrar prioridad",
      all_priorities: "Todas las prioridades",
      smart_suggestions: "Sugerencias Inteligentes",
      inactive_clients_coupon: "clientes inactivos - Enviar cupón",
      pending_proposals_reminder: "propuestas pendientes - Recordar",
      create_exclusive_package: "Crear paquete exclusivo Top 10",
      open: "Abiertos",
      won: "Ganados",
      conversion: "Conversión",
      closed_revenue: "Ingresos Cerrados",
      no_opportunities: "Sin oportunidades",
      drag_drop_hint: "Arrastra las tarjetas para mover entre etapas",
      stage_settings: "Configurar Etapas",
      stage_name: "Nombre de la Etapa",
      stage_color: "Color",
      add_stage: "Añadir Etapa",
      edit_stage: "Editar Etapa",
      delete_stage: "Eliminar Etapa",
      delete_stage_confirm: "¿Estás seguro de que quieres eliminar la etapa \"{{name}}\"?",
      delete_stage_warning: "Los negocios en esta etapa se moverán a \"Lead\".",
      priority_high: "Alta",
      priority_medium: "Media",
      priority_low: "Baja",
      none: "Ninguno",
      select_client: "Selecciona un cliente",
    },
    
    // Reports
    reports: {
      title: "Informes",
      subtitle: "Análisis de rendimiento del negocio",
      export_pdf: "Exportar PDF",
      exporting: "Exportando...",
      pdf_exported: "¡PDF exportado con éxito!",
      pdf_error: "Error al exportar PDF",
      new_widget: "Nuevo Widget",
      overview: "Vista General",
      my_charts: "Mis Gráficos",
      financial_report_title: "Informe Financiero",
      no_widgets: "Ningún widget creado",
      create_widgets_desc: "Crea gráficos personalizados para seguir tus métricas",
      create_widget: "Crear Widget",
      top_clients: "Mejores Clientes",
      visits: "visitas",
      total_spent: "total gastado",
      monthly_revenue_chart: "Ingresos Mensuales",
      agenda_analysis: "Análisis completo de citas",
      financial_analysis: "Análisis completo de finanzas",
      marketing_analysis: "Análisis de campañas de marketing",
      kpis: {
        monthly_revenue: "Ingresos Mensuales",
        avg_ticket: "Ticket Promedio",
        today_appointments: "Citas de Hoy",
        completed: "completadas",
        total_clients: "Total de Clientes",
        new: "nuevos",
        monthly_expenses: "Gastos Mensuales",
        net_profit: "Beneficio Neto",
        positive: "Positivo",
        negative: "Negativo",
      },
      charts: {
        monthly_revenue: "Ingresos Mensuales",
        best_clients: "Mejores Clientes",
        no_clients: "Ningún cliente registrado",
        visits: "visitas",
        total_spent: "total gastado",
      },
      report_types: {
        agenda: "Informe de Agenda",
        agenda_desc: "Tasa de ocupación, horarios pico y ausencias.",
        financial: "Informe Financiero",
        financial_desc: "Estado de resultados, flujo de caja y análisis de gastos.",
        marketing: "Informe de Marketing",
        marketing_desc: "Campañas enviadas, tasas de apertura y conversiones.",
      },
      agenda_report: {
        title: "Informe de Agenda",
        description: "Análisis completo de citas",
        total_appointments: "Total de Citas",
        occupancy_rate: "Tasa de Ocupación",
        cancellations: "Cancelaciones",
        no_show: "No Asistió",
        completed: "Completadas",
        cancelled: "Canceladas",
        status_distribution: "Distribución por Estado",
      },
      financial_report: {
        title: "Informe Financiero",
        description: "Flujo de caja y análisis detallado",
        income: "Ingresos",
        expenses: "Gastos",
        balance: "Balance",
        cash_flow: "Flujo de Caja",
        expense_breakdown: "Desglose de Gastos",
      },
      marketing_report: {
        title: "Informe de Marketing",
        description: "Rendimiento de campañas",
        total_campaigns: "Campañas Enviadas",
        total_recipients: "Total Destinatarios",
        open_rate: "Tasa de Apertura",
        click_rate: "Tasa de Clics",
        campaign_performance: "Rendimiento de Campañas",
        opened: "Abiertas",
        clicked: "Clickeadas",
      },
    },
    
    // Loyalty
    loyalty: {
      title: "Fidelización",
      subtitle: "Programa de puntos, cashback y cupones",
      points_issued: "Puntos Emitidos",
      available_cashback: "Cashback Disponible",
      active_coupons: "Cupones Activos",
      config: "Configuración",
      coupons: "Cupones",
      customers: "Clientes",
      loyalty_program: "Programa de Fidelización",
      program_rules: "Configura las reglas de puntos y cashback",
      program_active: "Programa Activo",
      program_active_desc: "Activar o desactivar el programa de fidelización",
      points_per_currency: "Puntos por €1,00",
      points_per_currency_hint: "Ej: 0.1 = 1 punto cada €10,00",
      cashback_percent: "Cashback (%)",
      cashback_percent_hint: "Porcentaje de cashback sobre compras",
      expiration_days: "Expiración de Puntos (días)",
      expiration_days_hint: "Deja vacío para que no expiren",
      never_expires: "Nunca expira",
      save_config: "Guardar Configuración",
      search_coupon: "Buscar cupón...",
      all: "Todos",
      active: "Activos",
      expired: "Expirados",
      exhausted: "Agotados",
      inactive: "Inactivos",
      new_coupon: "Nuevo Cupón",
      create_coupon: "Crear Cupón",
      code: "Código",
      generate: "Generar",
      discount_type: "Tipo de Descuento",
      percent: "Porcentaje (%)",
      fixed: "Valor Fijo (€)",
      discount_value: "Valor",
      min_amount: "Monto Mínimo (€)",
      max_uses: "Usos Máximos",
      unlimited: "Ilimitado",
      valid_until: "Válido Hasta",
      no_coupons: "Ningún cupón creado",
      no_coupons_found: "Ningún cupón encontrado",
      code_required: "Ingresa el código del cupón",
      code_copied: "¡Código copiado!",
      uses: "usos",
      clients_with_loyalty: "Clientes con Fidelización",
      search_client: "Buscar cliente...",
      points: "Puntos",
      cashback: "Cashback",
      no_clients_loyalty: "Ningún cliente ha acumulado puntos o cashback aún.",
    },
    
    // Settings
    settings: {
      title: "Configuración",
      subtitle: "Gestiona la configuración de tu negocio",
      business: "Negocio",
      services: "Servicios",
      team: "Equipo",
      integrations: "Integraciones",
      notifications: "Notificaciones",
      billing: "Facturación",
      units: "Unidades",
      
      // Language
      language: "Idioma",
      language_title: "Idioma del Sistema",
      language_description: "Elige el idioma de la interfaz",
      
      // Profile
      profile_photo: "Foto de Perfil",
      profile_photo_desc: "Esta foto se mostrará en la comunicación interna y en tu perfil",
      change_photo: "Cambiar foto",
      uploading: "Subiendo...",
      
      // Business
      business_data: "Datos del Negocio",
      business_data_desc: "Información que ven tus clientes",
      business_name: "Nombre del Negocio",
      phone_with_ddi: "Teléfono (con código de país)",
      address: "Dirección",
      address_placeholder: "Calle, número, barrio, ciudad - Estado",
      cnpj: "NIF/CIF",
      slug: "Enlace personalizado",
      slug_desc: "Este slug se usará en las URLs públicas del catálogo, reservas y linktree",
      save_data: "Guardar Cambios",
      public_url: "URL pública",
      
      // Hours
      hours: "Horarios",
      hours_title: "Horario de Atención",
      hours_desc: "Configura tus días y horas de trabajo",
      start_time: "Inicio",
      end_time: "Fin",
      working_days: "Días de Trabajo",
      save_hours: "Guardar Horarios",
      
      // Weekdays
      weekdays: {
        sun: "Dom",
        mon: "Lun",
        tue: "Mar",
        wed: "Mié",
        thu: "Jue",
        fri: "Vie",
        sat: "Sáb",
      },
      
      // Notifications
      push_notifications: "Notificaciones Push",
      push_notifications_desc: "Recibe recordatorios de citas directamente en tu navegador",
      notifications_active: "Notificaciones activas",
      notifications_active_desc: "Recibirás recordatorios de citas",
      notifications_blocked: "Las notificaciones han sido bloqueadas por tu navegador. Para activarlas, ve a la configuración del navegador → Privacidad y seguridad → Configuración del sitio → Notificaciones, y permite las notificaciones para este sitio.",
      notifications_not_supported: "Tu navegador no soporta notificaciones push",
      notifications_not_supported_desc: "Para recibir notificaciones, usa un navegador moderno como Chrome, Firefox, Edge o Safari.",
      enable_notifications: "Activar Notificaciones",
      reminder_15min: "Recordatorio 15 min antes",
      reminder_30min: "Recordatorio 30 min antes",
      new_appointments_notif: "Nuevas citas",
      
      // Email notifications
      email_notifications: "Notificaciones por Correo",
      email_notifications_desc: "Configura las notificaciones que recibes por correo",
      email_new_appointments: "Correos de nuevas citas",
      email_new_appointments_desc: "Recibir cuando un cliente reserve",
      appointment_reminders: "Recordatorios de citas",
      appointment_reminders_desc: "Alerta 15min antes de la cita",
      weekly_report: "Informe semanal",
      weekly_report_desc: "Resumen de rendimiento cada lunes",
      low_stock_alerts: "Alertas de stock bajo",
      low_stock_alerts_desc: "Cuando los productos se estén agotando",
      save_notifications: "Guardar Notificaciones",
    },
    
    // Auth
    auth: {
      login: "Iniciar Sesión",
      register: "Crear Cuenta",
      logout: "Salir",
      email: "Correo electrónico",
      password: "Contraseña",
      confirm_password: "Confirmar Contraseña",
      forgot_password: "¿Olvidaste la contraseña?",
      reset_password: "Restablecer Contraseña",
      full_name: "Nombre Completo",
      already_have_account: "¿Ya tienes una cuenta?",
      dont_have_account: "¿No tienes una cuenta?",
      or_continue_with: "o continúa con",
      logging_in: "Iniciando sesión...",
      creating_account: "Creando cuenta...",
    },
    
    // Languages
    languages: {
      pt: "Português",
      en: "English",
      es: "Español",
    },
    
    // Errors
    errors: {
      generic: "Ocurrió un error. Inténtalo de nuevo.",
      required_field: "Este campo es obligatorio",
      invalid_email: "Correo electrónico inválido",
      invalid_phone: "Teléfono inválido",
      photo_update_error: "Error al actualizar la foto",
    },
    
    // Success messages
    success: {
      saved: "¡Guardado con éxito!",
      deleted: "¡Eliminado con éxito!",
      updated: "¡Actualizado con éxito!",
      photo_updated: "¡Foto de perfil actualizada!",
      hours_saved: "¡Horarios guardados con éxito!",
      notifications_saved: "¡Preferencias de notificación guardadas!",
    },

    // Changelog
    changelog: {
      title: "Novedades",
      loading: "Cargando...",
      no_updates: "No hay actualizaciones disponibles",
      new: "Nuevo",
      improvement: "Mejora",
      fix: "Corrección",
    },

    // Insights
    insights: {
      title: "Insights con IA",
      subtitle: "Análisis inteligentes y sugerencias para tu negocio",
      generate: "Generar Insights",
      analyzing: "Analizando...",
      active_insights: "Insights Activos",
      high_priority: "Alta Prioridad",
      about_revenue: "Sobre Ingresos",
      dismissed: "Descartados",
      search_placeholder: "Buscar insights...",
      filter_type: "Tipo",
      filter_priority: "Prioridad",
      all_types: "Todos los tipos",
      revenue: "Ingresos",
      customers: "Clientes",
      appointments: "Citas",
      inventory: "Inventario",
      alerts: "Alertas",
      all_priorities: "Todas",
      high: "Alta",
      medium: "Media",
      low: "Baja",
      loading: "Cargando insights...",
      no_insights: "No hay insights disponibles",
      no_insights_found: "No se encontraron insights",
      no_insights_desc: "Haz clic en \"Generar Insights\" para que la IA analice tus datos y sugiera mejoras para tu negocio.",
      adjust_filters: "Intenta ajustar los filtros",
      dismiss_insight: "Descartar insight",
      generated_at: "Generado el",
      dismissed_insights: "Insights Descartados",
    },

    // PDV
    pdv: {
      title: "TPV",
      subtitle: "Punto de venta rápido",
      quick_sale: "Venta Rápida",
      tables: "Mesas",
      wristbands: "Pulseras",
      cash_open: "Caja Abierta",
      open_cash: "Abrir Caja",
      quick_links: "Enlaces Rápidos:",
      waiter_tables: "Camarero - Mesas",
      waiter_wristbands: "Camarero - Pulseras",
      security: "Seguridad",
      kitchen: "Cocina",
      search_placeholder: "Buscar producto o servicio...",
      products: "Productos",
      services: "Servicios",
      all: "Todos",
      no_items: "No se encontraron items",
      out_of_stock: "Producto sin stock",
      insufficient_stock: "Stock insuficiente",
      max_available: "Cantidad máxima disponible",
      cart: "Carrito",
      customer: "Cliente (opcional)",
      no_customer: "Sin cliente",
      select_customer: "Seleccionar cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Cliente no encontrado.",
      empty_cart: "Carrito vacío",
      discount: "Descuento",
      payment_method: "Método de pago",
      cash: "Efectivo",
      credit_card: "Tarjeta de Crédito",
      debit_card: "Tarjeta de Débito",
      pix: "PIX",
      subtotal: "Subtotal",
      total: "Total",
      finalize_sale: "Finalizar Venta",
      processing: "Procesando...",
      sale_completed: "¡Venta Completada!",
      no_sku: "Sin SKU",
      without_stock: "Sin stock",
    },

    // Clinic
    clinic: {
      title: "Clínica",
      subtitle: "Historial médico electrónico, anamnesis y evolución clínica",
      patients: "Pacientes",
      records: "Historiales",
      evolutions: "Evoluciones",
      photos: "Fotos",
      search_patient: "Buscar paciente...",
      no_patients: "No se encontraron pacientes",
      record: "Historial",
      last_appointment: "Última cita",
      no_contact: "Sin contacto",
      select_patient: "Selecciona un paciente para ver el historial",
      new_anamnesis: "Nueva Anamnesis",
      new_evolution: "Nueva Evolución",
      suggest_treatment: "Sugerir Tratamiento",
      anamnesis: "Anamnesis",
      prescription: "Prescripción",
      evolution: "Evolución",
      exam: "Examen",
      consent: "Consentimiento",
      chief_complaint: "Queja Principal",
      chief_complaint_placeholder: "Describe la queja principal del paciente...",
      medical_history: "Historial Médico",
      medical_history_placeholder: "Enfermedades previas, cirugías, hospitalizaciones...",
      allergies: "Alergias",
      allergies_placeholder: "Medicamentos, alimentos, otros...",
      medications: "Medicamentos Actuales",
      medications_placeholder: "Lista los medicamentos...",
      family_history: "Historial Familiar",
      family_history_placeholder: "Enfermedades en la familia...",
      lifestyle: "Hábitos y Estilo de Vida",
      lifestyle_placeholder: "Tabaquismo, alcohol, actividad física...",
      save_anamnesis: "Guardar Anamnesis",
      ai_suggestion: "Sugerencia IA",
      not_informed: "No informado",
      appointments_count: "Citas",
      records_count: "Registros",
      clinical_history: "Historial Clínico",
      no_records: "No se encontraron registros",
      no_records_desc: "Crea una anamnesis o evolución para comenzar",
      appointment: "Cita",
      no_notes: "Sin observaciones registradas",
      see_details: "Ver Detalles",
      clinical_evolutions: "Evoluciones Clínicas",
      select_patient_evolutions: "Selecciona un paciente y registra evoluciones",
      evolution_photos: "Fotos de Evolución",
      add_photo: "Agregar Foto",
      no_photos: "No hay fotos de evolución registradas",
      no_photos_desc: "Agrega fotos antes/después para seguir la evolución del tratamiento",
      new_clinical_evolution: "Nueva Evolución Clínica",
      patient: "Paciente",
      select_patient_form: "Selecciona el paciente...",
      title_field: "Título",
      title_placeholder: "Ej: Seguimiento - Evaluación",
      evolution_field: "Evolución",
      evolution_placeholder: "Describe la evolución del paciente...",
      save_evolution: "Guardar Evolución",
      ai_suggestion_title: "Sugerencia de IA",
      select_patient_first: "Selecciona un paciente primero.",
      ai_error: "Error al procesar sugerencia con IA.",
    },

    // Header
    header: {
      notifications: "Notificaciones",
      mark_all: "Marcar todas",
      no_notifications: "Sin notificaciones",
      search_placeholder: "Buscar... (Ctrl+K)",
      expand_menu: "Expandir menú",
      collapse_menu: "Minimizar menú",
      my_profile: "Mi Perfil",
      subscription: "Suscripción",
      admin_panel: "Panel Admin",
      help_center: "Centro de Ayuda",
      support: "Soporte",
      logout: "Salir",
    },

    // Quick Replies (Chatbot)
    quick_replies: {
      title: "Respuestas Rápidas",
      description: "Configura mensajes predefinidos para agilizar la atención",
      new_reply: "Nueva Respuesta",
      edit_reply: "Editar Respuesta Rápida",
      title_shortcut: "Título (atajo)",
      title_placeholder: "Ej: Saludo, Agradecimiento, Horario...",
      title_help: "Un nombre corto para identificar la respuesta",
      message: "Mensaje",
      message_placeholder: "Ej: ¡Hola! Gracias por contactarnos. ¿Cómo puedo ayudarte?",
      message_help: "El mensaje completo que se enviará",
      saving: "Guardando...",
      no_replies: "No hay respuestas rápidas creadas",
      no_replies_desc: "Crea respuestas para agilizar tu atención",
      confirm_delete: "¿Estás seguro de que deseas eliminar esta respuesta rápida?",
      title_message_required: "Título y mensaje son obligatorios",
    },

    // Agenda Banners
    agenda_banners: {
      title: "Banners de Agenda",
      description: "Agrega banners promocionales para mostrar en la página de agenda",
      add: "Agregar",
      edit_banner: "Editar Banner",
      title_optional: "Título (opcional)",
      title_placeholder: "Ej: Promoción de Verano",
      link_optional: "Link (opcional)",
      apply: "Aplicar",
      save_banners: "Guardar Banners",
      image_uploaded: "¡Imagen cargada! Guarda para aplicar.",
      upload_error: "Error al subir",
    },

    // PDV Tables
    pdv_tables: {
      table: "Mesa",
      tables: "Mesas",
      manage_tables: "Gestionar Mesas",
      new_table: "Nueva Mesa",
      create_table: "Crear Mesa",
      table_number: "Número de Mesa",
      table_name: "Nombre (opcional)",
      capacity: "Capacidad",
      people: "personas",
      available: "Disponible",
      occupied: "Ocupada",
      reserved: "Reservada",
      open_table: "Abrir Mesa",
      close_table: "Cerrar Mesa",
      table_closed: "¡Mesa Cerrada!",
      back: "Volver",
      opened: "Abierta",
      order: "Comanda",
      no_items: "Sin items",
      search_item: "Buscar item...",
      products: "Productos",
      services: "Servicios",
      qr_codes: "Códigos QR",
      download_qr: "Descargar QR",
      print_all: "Imprimir Todos",
      customer: "Cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Cliente no encontrado",
      new_customer: "Nuevo Cliente",
      register_customer: "Registrar Cliente",
      name_required: "El nombre es obligatorio",
      customer_registered: "¡Cliente registrado!",
      customer_error: "Error al registrar cliente",
      confirm_open: "Confirmar Apertura",
      no_tables: "No hay mesas registradas",
      create_first_table: "Crea la primera mesa",
      delete_confirm: "Eliminar mesa",
    },

    // Cash Register
    cash_register: {
      title: "Control de Caja",
      description: "Gestiona apertura, cierre y movimientos de caja",
      current: "Actual",
      movements: "Movimientos",
      history: "Historial",
      open_register: "Abrir Caja",
      close_register: "Cerrar Caja",
      opening_amount: "Monto de Apertura",
      closing_amount: "Monto en Caja",
      observations: "Observaciones",
      observations_open: "Observaciones sobre la apertura...",
      observations_close: "Observaciones sobre el cierre...",
      opening: "Apertura",
      inflows: "Entradas",
      outflows: "Salidas",
      expected_balance: "Saldo Esperado",
      opened_at: "Abierto el",
      difference: "Diferencia",
      new_movement: "Nuevo Movimiento",
      sangria: "Retiro",
      suprimento: "Suministro",
      amount: "Monto",
      movement_description: "Descripción",
      movement_placeholder: "Motivo del movimiento...",
      register_sangria: "Registrar Retiro",
      register_suprimento: "Registrar Suministro",
      daily_movements: "Movimientos del Día",
      no_movements: "Sin movimientos registrados",
      sale: "Venta",
      refund: "Reembolso",
      open_to_register: "Abre la caja para registrar movimientos",
      date_from: "Desde",
      date_to: "Hasta",
      clear: "Limpiar",
      no_history: "No se encontraron registros de caja",
      no_history_period: "No se encontraron registros en el período",
      open: "Abierto",
      closed: "Cerrado",
      closing: "Cierre",
      register_opened: "¡Caja abierta con éxito!",
      register_closed: "¡Caja cerrada con éxito!",
      movement_registered: "¡registrado!",
      error_open: "Error al abrir caja",
      error_close: "Error al cerrar caja",
      error_movement: "Error al registrar movimiento",
      details: "Detalles de Caja",
      copy: "Copiar",
      whatsapp: "WhatsApp",
      expected_value: "Valor Esperado",
      counted_value: "Valor Contado",
      balanced: "✓ ¡Caja cuadrada!",
      number_not_configured: "Número no configurado",
      configure_whatsapp: "Configura el número de WhatsApp en ajustes del negocio",
      report_sent: "¡Informe enviado vía WhatsApp!",
      send_error: "Error al enviar",
      send_error_desc: "No se pudo enviar el informe vía WhatsApp",
      report_copied: "¡Informe copiado!",
      products_sold: "Productos Vendidos",
      financial_summary: "Resumen Financiero",
      sales_by_payment: "Ventas por Forma de Pago",
      totals: "Totales",
      gross_revenue: "Ingresos Brutos",
      product_cost: "Costo de Productos",
      gross_profit: "Lucro Bruto",
      sales_suprim: "Ventas + Suministros",
      sangria_refund: "Retiros + Reembolsos",
      no_movement: "Sin movimientos",
    },

    // Wristbands
    wristbands: {
      title: "Pulseras",
      active_wristbands: "Pulseras Activas",
      new: "Nueva",
      no_active: "Sin pulseras activas",
      wristband: "Pulsera",
      cancel: "Cancelar",
      close: "Cerrar",
      search_product_service: "Buscar producto o servicio...",
      consumption: "Consumo",
      no_items: "Sin items añadidos",
      select_wristband: "Selecciona una pulsera",
      select_wristband_desc: "Haz clic en una pulsera activa o crea una nueva",
      new_wristband: "Nueva Pulsera",
      wristband_code: "Código de Pulsera *",
      code_placeholder: "Ej: A001, 123, etc",
      customer: "Cliente",
      search_customer: "Buscar por nombre, teléfono o ID...",
      no_customer_found: "Cliente no encontrado",
      register_new: "Registrar Nuevo",
      create_wristband: "Crear Pulsera",
      quick_customer: "Registro Rápido de Cliente",
      name_required: "Nombre *",
      customer_name: "Nombre del cliente",
      phone: "Teléfono",
      cpf: "Documento",
      birth_date: "Fecha de Nacimiento",
      register_select: "Registrar y Seleccionar",
      close_wristband: "Cerrar Pulsera",
      subtotal: "Subtotal",
      discount: "Descuento",
      payment_method: "Forma de Pago",
      cash: "Efectivo",
      credit: "Tarjeta Crédito",
      debit: "Tarjeta Débito",
      pix: "PIX",
      no_register_warning: "⚠️ Sin caja abierta. El pago se registrará pero no entrará en control de caja.",
      confirm_payment: "Confirmar Pago",
      wristband_created: "¡Pulsera creada!",
      wristband_closed: "¡Pulsera cerrada con éxito!",
      wristband_cancelled: "Pulsera cancelada",
      item_added: "¡añadido!",
      error_create: "Error al crear pulsera",
      error_add_item: "Error al añadir item",
      error_close: "Error al cerrar pulsera",
      error_cancel: "Error al cancelar",
      customer_registered: "¡Cliente registrado!",
      error_customer: "Error al registrar cliente",
      enter_name: "Ingresa el nombre del cliente",
      enter_code: "Ingresa el código de pulsera",
      discount_exceed: "El descuento no puede ser mayor al total",
    },

    // Chat
    chat: {
      emojis: "Emojis",
      image: "Imagen",
      document: "Documento",
      video: "Video",
      quick_replies_click: "Respuestas Rápidas (clic para enviar)",
      recording: "Grabando",
      type_message: "Escribe tu mensaje...",
      microphone_error: "No se pudo acceder al micrófono",
      contact_details: "Detalles del Contacto",
      whatsapp_contact: "Contacto WhatsApp",
      registered_customer: "Cliente registrado",
      contact_only: "Solo contacto",
      visits: "Visitas",
      total_spent: "Total gastado",
      view_full_details: "Ver Detalles Completos",
      create_lead: "Crear Lead / Cliente",
      name_required: "Nombre es obligatorio",
      customer_name: "Nombre del cliente",
      lead_notes: "Notas sobre el lead...",
      create_lead_button: "Crear Lead",
      conversation_tags: "Etiquetas de Conversaciones",
      tags_description: "Crea etiquetas personalizadas para organizar tus conversaciones",
      new_tag: "Nueva Etiqueta",
      edit_tag: "Editar Etiqueta",
      tag_name: "Nombre de la Etiqueta",
      tag_placeholder: "Ej: Urgente, VIP, Nuevo Cliente...",
      tag_name_required: "Nombre de la etiqueta es obligatorio",
      no_tags: "Ninguna etiqueta creada",
      create_tags_organize: "Crea etiquetas para organizar tus conversaciones",
    },

    // Medical Records
    medical_records: {
      title: "Historial Médico Electrónico",
      subtitle: "Anamnesis, evolución clínica e historial de pacientes",
      patients: "Pacientes",
      records: "Historiales",
      evolutions: "Evoluciones",
      photos: "Fotos",
      search_patient: "Buscar paciente...",
      no_patient_found: "Ningún paciente encontrado",
      no_patients: "Ningún paciente encontrado",
      no_contact: "Sin contacto",
      record: "Historial",
      select_patient_to_view: "Selecciona un paciente para ver el historial",
      medications_in_use: "Medicamentos Actuales",
      select_patient_first: "Selecciona un paciente primero.",
      fill_chief_complaint: "Completa la queja principal.",
      fill_evolution_content: "Completa el contenido de la evolución.",
      select_photo: "Selecciona una foto.",
      new_anamnesis: "Nueva Anamnesis",
      anamnesis: "Anamnesis",
      chief_complaint: "Queja Principal",
      chief_complaint_placeholder: "Describe la queja principal del paciente...",
      medical_history: "Historial Médico",
      medical_history_placeholder: "Enfermedades previas, cirugías, hospitalizaciones...",
      allergies: "Alergias",
      allergies_placeholder: "Medicamentos, alimentos, otros...",
      medications: "Medicamentos Actuales",
      medications_placeholder: "Lista los medicamentos...",
      family_history: "Historial Familiar",
      family_history_placeholder: "Enfermedades familiares...",
      lifestyle: "Estilo de Vida",
      lifestyle_placeholder: "Hábitos, actividades físicas...",
      save_anamnesis: "Guardar Anamnesis",
      ai_suggestion: "Sugerencia IA",
      new_evolution: "Nueva Evolución",
      clinical_evolution: "Evolución Clínica",
      evolution: "Evolución",
      evolution_placeholder: "Describe la evolución del paciente...",
      diagnosis: "Diagnóstico",
      diagnosis_placeholder: "Diagnóstico o hipótesis diagnóstica...",
      treatment: "Tratamiento",
      treatment_placeholder: "Plan de tratamiento...",
      observations: "Observaciones",
      observations_placeholder: "Observaciones adicionales...",
      save_evolution: "Guardar Evolución",
      add_photo: "Agregar Foto",
      upload_photo: "Subir Foto",
      select_file: "Selecciona un archivo",
      photo_description: "Descripción",
      photo_description_placeholder: "Descripción de la foto...",
      photo_category: "Categoría",
      category_placeholder: "Ej: Antes, Después, Examen...",
      upload: "Subir",
      select_patient_record: "Selecciona un paciente para ver el historial",
      anamnesis_history: "Historial de Anamnesis",
      no_anamnesis: "Ninguna anamnesis registrada",
      evolutions_history: "Evoluciones Clínicas",
      no_evolutions: "Ninguna evolución registrada",
      photo_gallery: "Galería de Fotos",
      no_photos: "Ninguna foto registrada",
      delete_photo: "Eliminar Foto",
      delete_photo_confirm: "¿Estás seguro de que deseas eliminar esta foto?",
      ai_suggestion_title: "Sugerencia de IA",
      ai_error: "Error al procesar sugerencia con IA.",
    },

    // Contracts
    contracts: {
      title: "Contratos",
      new_template: "Nueva Plantilla",
      new_contract: "Nuevo Contrato",
      create_template: "Crear Plantilla de Contrato",
      template_name: "Nombre de la plantilla",
      template_content: "Contenido del contrato. Usa {{nombre_cliente}}, {{email_cliente}}, {{fecha_actual}} como marcadores.",
      create_template_btn: "Crear Plantilla",
      generate_contract: "Generar Contrato",
      edit_contract: "Editar Contrato",
      select_client: "Selecciona el cliente",
      search_client: "Buscar cliente...",
      no_client_found: "Ningún cliente encontrado.",
      select_template: "Selecciona una plantilla (opcional)",
      search_template: "Buscar plantilla...",
      no_template_found: "Ninguna plantilla encontrada.",
      contract_content: "Contenido del contrato",
      save_changes: "Guardar Cambios",
      create_contract_btn: "Crear Contrato",
      total: "Total",
      drafts: "Borradores",
      sent: "Enviados",
      signed: "Firmados",
      contracts_tab: "Contratos",
      templates_tab: "Plantillas",
      search_by_client: "Buscar por cliente...",
      all_status: "Todos los estados",
      draft: "Borrador",
      cancelled: "Cancelado",
      loading: "Cargando...",
      no_contracts: "Ningún contrato encontrado",
      created_at: "Creado el",
      signed_at: "Firmado el",
      copy_link: "Copiar Enlace",
      open_link: "Abrir Enlace",
      no_templates: "Ninguna plantilla creada",
      contract_details: "Detalles del Contrato",
      close: "Cerrar",
      print: "Imprimir",
      share: "Compartir",
      send_signature: "Enviar para Firma",
      signature_pending: "Firma Pendiente",
      delete_contract: "Eliminar Contrato",
      delete_contract_confirm: "¿Estás seguro de que deseas eliminar este contrato?",
      delete_template: "Eliminar Plantilla",
      delete_template_confirm: "¿Estás seguro de que deseas eliminar esta plantilla?",
      link_copied: "¡Enlace copiado!",
      client: "Cliente",
      signer_ip: "IP del Firmante",
      share_contract: "Compartir Contrato",
      no_contract_found: "Ningún contrato encontrado",
      no_template_found_msg: "Ninguna plantilla encontrada",
      status: {
        draft: "Borrador",
        sent: "Enviado",
        signed: "Firmado",
        cancelled: "Cancelado",
      },
    },

    // Training
    training: {
      title: "Capacitación",
      subtitle: "Capacitación y desarrollo del equipo",
      new_course: "Nuevo Curso",
      create_course: "Crear Nuevo Curso",
      course_title: "Título",
      course_name: "Nombre del curso",
      course_description: "Descripción",
      course_description_placeholder: "Descripción del curso",
      create_course_btn: "Crear Curso",
      courses: "Cursos",
      in_progress: "En progreso",
      completed: "Completados",
      pending: "Pendientes",
      search_course: "Buscar curso...",
      all: "Todos",
      enrolled: "Matriculado",
      not_enrolled: "No matriculado",
      loading: "Cargando...",
      no_courses: "Ningún curso creado",
      no_courses_found: "Ningún curso encontrado",
      no_description: "Sin descripción",
      select_course: "Selecciona un curso",
      select_course_desc: "Selecciona un curso para ver y editar el contenido",
      module: "Módulo",
      add_module: "Agregar Módulo",
      module_title: "Título del Módulo",
      module_title_placeholder: "Ej: Introducción",
      module_description: "Descripción",
      module_description_placeholder: "Descripción del módulo",
      create_module_btn: "Crear Módulo",
      no_modules: "Ningún módulo creado",
      add_module_tip: "Haz clic en \"Módulo\" para agregar contenido",
      add_lesson: "Agregar Lección",
      lesson_title: "Título de la Lección",
      lesson_title_placeholder: "Ej: Bienvenida",
      lesson_content: "Contenido",
      lesson_content_placeholder: "Contenido de la lección...",
      video_url: "URL del Video (opcional)",
      duration: "Duración (min)",
      create_lesson_btn: "Crear Lección",
      no_lessons: "Agrega lecciones al módulo",
      enroll: "Matricularse",
      enrollment: "Matrícula",
      status: {
        completed: "Completado",
        in_progress: "En progreso",
        not_started: "No iniciado",
      },
      module_created: "¡Módulo creado!",
      lesson_created: "¡Lección creada!",
      module_deleted: "¡Módulo eliminado!",
      lesson_deleted: "¡Lección eliminada!",
    },

    // Forms
    forms: {
      title: "Formularios",
      subtitle: "Crea formularios personalizados para recolección de datos",
      new_form: "Nuevo Formulario",
      create_form: "Crear Formulario",
      form_config: "Configura las opciones del nuevo formulario",
      form_name: "Nombre",
      form_name_placeholder: "Ej: Ficha de Anamnesis",
      form_description: "Descripción",
      form_description_placeholder: "Descripción del formulario",
      form_type: "Tipo",
      type_generic: "Genérico",
      type_pre_attendance: "Pre-Atención",
      type_survey: "Encuesta",
      expiration_date: "Fecha de Expiración (opcional)",
      allow_image: "Permitir subida de imagen",
      capture_location: "Capturar ubicación",
      creating: "Creando...",
      create_btn: "Crear",
      forms: "Formularios",
      forms_count: "Formularios",
      active: "Activos",
      responses: "Respuestas",
      your_forms: "Tus Formularios",
      search: "Buscar...",
      type: "Tipo",
      all_types: "Todos los tipos",
      all: "Todos",
      all_status: "Todos",
      generic: "Genérico",
      pre_attendance: "Pre-Atención",
      survey: "Encuesta",
      active_only: "Activos",
      inactive: "Inactivos",
      inactive_only: "Inactivos",
      loading: "Cargando...",
      no_forms: "Ningún formulario creado",
      no_forms_found: "Ningún formulario encontrado",
      no_description: "Sin descripción",
      expires: "Expira",
      fields: "Campos",
      responses_tab: "Respuestas",
      add_field: "Agregar Campo",
      field_label: "Nombre del campo",
      field_label_placeholder: "Nombre del campo",
      field_type: "Tipo",
      type_text: "Texto",
      type_number: "Número",
      type_boolean: "Sí/No",
      type_select: "Selección",
      add_btn: "Agregar",
      no_fields: "Ningún campo agregado",
      settings: "Configuración",
      copy_link: "Copiar Enlace",
      open_link: "Abrir Enlace",
      toggle_status: "Activar/Desactivar",
      delete_form: "Eliminar",
      select_form: "Selecciona un formulario",
      select_form_desc: "Selecciona un formulario a la izquierda para ver o editar",
      options_modal: "Opciones del Campo",
      options_modal_desc: "Agrega las opciones para este campo de selección",
      option_placeholder: "Nueva opción",
      add_option: "Agregar",
      confirm_options: "Confirmar Opciones",
      add_at_least_one: "Agrega al menos una opción",
      form_settings: "Configuración del Formulario",
      form_settings_desc: "Ajusta las configuraciones avanzadas del formulario",
      save_settings: "Guardar Configuración",
      link_copied: "¡Enlace copiado!",
    },

    // Customer Plans
    customer_plans: {
      title: "Planes de Clientes",
      subtitle: "Gestiona planes recurrentes para tus clientes",
      new_plan: "Nuevo Plan",
      subscribe_client: "Suscribir Cliente",
      create_plan: "Crear Plan",
      plan_name: "Nombre del plan",
      plan_name_placeholder: "Ej: Plan Mensual Premium",
      plan_description: "Qué está incluido...",
      plan_value: "Valor",
      periodicity: "Periodicidad",
      monthly: "Mensual",
      yearly: "Anual",
      create_plan_btn: "Crear Plan",
      subscribe_plan: "Suscribir Cliente a Plan",
      client: "Cliente",
      select_client: "Selecciona el cliente",
      search_client: "Buscar cliente...",
      no_client_found: "Ningún cliente encontrado.",
      plan: "Plan",
      select_plan: "Selecciona el plan",
      search_plan: "Buscar plan...",
      no_plan_found: "Ningún plan encontrado.",
      start_date: "Fecha de inicio",
      subscribe_btn: "Suscribir",
      total: "Total",
      active: "Activos",
      expiring: "Por vencer",
      overdue: "Vencidos",
      subscriptions: "Suscripciones",
      plans: "Planes",
      search: "Buscar por cliente o plan...",
      all: "Todos",
      active_only: "Activos",
      expiring_only: "Por vencer",
      overdue_only: "Vencidos",
      cancelled: "Cancelados",
      loading: "Cargando...",
      no_subscriptions: "Sin suscripciones",
      no_subscriptions_found: "Ninguna suscripción encontrada",
      subscribe_clients: "Suscribe clientes a planes",
      adjust_filters: "Intenta ajustar los filtros",
      try_filters: "Intenta ajustar los filtros",
      start: "Inicio",
      next_due: "Próximo vencimiento",
      send_email_reminder: "Enviar recordatorio por e-mail",
      send_whatsapp_reminder: "Enviar recordatorio por WhatsApp",
      cancel_subscription: "Cancelar",
      reactivate: "Reactivar",
      status: {
        active: "Activa",
        cancelled: "Cancelada",
        overdue: "Vencida",
        expiring: "Vence en {{days}} días",
      },
      per_month: "mes",
      per_year: "año",
      no_plans: "Ningún plan creado",
      create_first: "Crea planes para suscribir clientes",
      edit_plan: "Editar",
      deactivate_plan: "Desactivar",
      activate_plan: "Activar",
      email_reminder_sent: "Recordatorio enviado por e-mail",
      email_reminder_desc: "E-mail enviado a {{name}} sobre el plan {{plan}}",
    },

    // Team
    team: {
      title: "Equipo",
      description: "Gestiona miembros con acceso y profesionales de agenda",
      with_access: "Con Acceso",
      pending: "Pendientes",
      agenda_only: "Solo Agenda",
      invite_member: "Invitar Miembro",
      no_members: "Sin miembros en el equipo",
      invite_desc: "Invita miembros para dar acceso al sistema",
      linked_agenda: "Vinculado a agenda",
      make_admin: "Hacer Admin",
      make_staff: "Hacer Colaborador",
      remove: "Eliminar",
      no_pending: "Sin invitaciones pendientes",
      expires_at: "Expira el",
      professionals_desc: "Profesionales que aparecen en la agenda pero no tienen acceso al sistema. Para dar acceso, invítalos en la pestaña \"Con Acceso\".",
      new_professional: "Nuevo Profesional",
      edit_professional: "Editar Profesional",
      full_name: "Nombre completo",
      registration: "Matrícula",
      employee_code: "Código de empleado",
      role: "Función",
      role_placeholder: "Ej: Peluquero, Manicurista",
      commission: "Comisión (%)",
      professional_active: "Profesional activo",
      create_professional: "Crear Profesional",
      no_professionals: "Sin profesionales registrados",
      register_desc: "Registra profesionales para usar en la agenda",
      no_role: "Sin función",
      commission_suffix: "comisión",
      invite_new: "Invitar Nuevo Miembro",
      permission: "Permiso",
      staff_default: "Colaborador (predeterminado)",
      admin: "Administrador",
      permission_desc: "Colaboradores tienen acceso limitado. Admins tienen acceso total.",
      send_invite: "Enviar Invitación",
      remove_member: "Eliminar miembro",
      remove_confirm: "¿Estás seguro de que deseas eliminar este miembro del equipo? Perderá acceso al sistema.",
      remove_btn: "Eliminar",
      owner: "Propietario",
      updated: "¡Profesional actualizado!",
      created: "¡Profesional creado!",
      error_update: "Error al actualizar profesional",
      name_required: "El nombre es obligatorio",
      inactive: "Inactivo",
    },

    // API Keys
    api_keys: {
      title: "Claves de API",
      description: "Gestiona tus claves de API para integración",
      new_key: "Nueva Clave",
      create_key: "Crear Clave",
      key_name: "Nombre de la Clave",
      key_name_placeholder: "Ej: Integración ERP",
      key_created: "¡Clave creada con éxito!",
      key_deleted: "Clave eliminada con éxito",
      copy_key: "Copiar Clave",
      key_copied: "¡Clave copiada!",
      show_key: "Mostrar Clave",
      hide_key: "Ocultar Clave",
      last_used: "Último uso",
      never_used: "Nunca usada",
      delete_confirm: "¿Estás seguro de que deseas eliminar esta clave?",
      delete_warning: "Esta acción no se puede deshacer. Las integraciones que usan esta clave dejarán de funcionar.",
      active: "Activa",
      inactive: "Inactiva",
      error_create: "Error al crear clave",
      error_delete: "Error al eliminar clave",
      name_required: "Ingresa un nombre para la clave",
      business_not_found: "Negocio no encontrado",
      keys_tab: "Mis Claves",
      docs_tab: "Documentación",
      playground_tab: "Playground",
      no_keys: "Sin claves de API creadas",
      create_first: "Crea tu primera clave para comenzar a integrar",
      warning_copy: "¡Copia tu clave ahora. No se mostrará de nuevo!",
      endpoints: "Endpoints",
      test: "Probar",
      testing: "Probando...",
      select_key: "Selecciona una clave",
      authentication: "Autenticación",
      auth_description: "Usa tu clave de API en el header Authorization:",
      prefix: "Prefijo",
      copy_code: "Copiar código",
      params: "Parámetros",
      body_example: "Body (ejemplo)",
      playground_description: "Prueba los endpoints de la API directamente en el navegador",
      create_to_test: "Crea una clave de API para probar los endpoints",
    },

    // Chatbot Knowledge
    chatbot_knowledge: {
      title: "Base de Conocimiento",
      description: "Entrena el chatbot con documentos y preguntas frecuentes",
      documents_tab: "Documentos",
      qa_tab: "Preguntas y Respuestas",
      add_document: "Agregar Documento",
      document_name: "Nombre del Documento",
      document_name_placeholder: "Ej: Política de cancelación",
      document_content: "Contenido",
      document_content_placeholder: "Pega aquí el contenido del documento que el chatbot debe conocer...",
      saving: "Guardando...",
      save_document: "Guardar Documento",
      no_documents: "Sin documentos agregados",
      no_documents_desc: "Agrega documentos como políticas, reglas, información sobre servicios, etc.",
      added_at: "Agregado el",
      add_question: "Agregar Pregunta",
      add_qa: "Agregar Pregunta y Respuesta",
      question: "Pregunta",
      question_placeholder: "Ej: ¿Cuál es el horario de atención?",
      answer: "Respuesta",
      answer_placeholder: "Ej: Abrimos de lunes a viernes, de 8am a 6pm.",
      save: "Guardar",
      no_questions: "Sin preguntas agregadas",
      no_questions_desc: "Agrega preguntas frecuentes y sus respuestas para respuestas rápidas del chatbot",
      documents_helper: "Agrega documentos para que el chatbot consulte durante las conversaciones",
      qa_helper: "Agrega preguntas frecuentes para respuestas rápidas y precisas",
    },

    // Staff
    staff: {
      title: "Profesionales",
      description: "Gestiona los profesionales que prestan servicios",
      new_professional: "Nuevo Profesional",
      edit_professional: "Editar Profesional",
      name: "Nombre",
      name_required: "El nombre es obligatorio",
      full_name: "Nombre completo",
      email: "E-mail",
      phone: "Teléfono",
      registration: "Matrícula",
      employee_code: "Código de empleado",
      cpf: "DNI/NIF",
      role: "Función",
      role_placeholder: "Ej: Peluquero, Manicurista",
      commission: "Comisión (%)",
      professional_active: "Profesional activo",
      save: "Guardar",
      create: "Crear Profesional",
      updated: "¡Profesional actualizado!",
      created: "¡Profesional creado!",
      error_update: "Error al actualizar profesional",
      no_professionals: "Sin profesionales registrados",
      no_role: "Sin función",
      commission_suffix: "comisión",
      inactive: "Inactivo",
    },

    // Linktree / Bio Page
    linktree: {
      title: "Bio Page",
      description: "Tu página de enlaces profesional",
      create_page: "Crear tu Bio Page",
      slug_not_configured: "Slug no configurado",
      slug_config_hint: "Configura un slug en Configuración → Datos del Negocio para crear tu Bio Page.",
      page_url: "URL de tu página",
      display_name: "Nombre para mostrar",
      display_name_placeholder: "Ej: Mi Empresa",
      create_bio: "Crear Bio Page",
      copy: "Copiar",
      view_site: "Ver Sitio",
      link_copied: "¡Enlace copiado!",
      views: "Vistas",
      clicks: "Clics",
      links: "Enlaces",
      my_links: "Mis Enlaces",
      new_link: "Nuevo Enlace",
      add_link: "Agregar Enlace",
      link_type: "Tipo de Enlace",
      link_title: "Título",
      link_url: "URL",
      link_description: "Descripción",
      link_icon: "Ícono/Emoji",
      button_style: "Estilo del Botón",
      save_link: "Guardar Enlace",
      edit_link: "Editar Enlace",
      no_links: "Sin enlaces agregados",
      add_first: "Agrega tu primer enlace",
      delete_link: "Eliminar enlace",
      design_tab: "Diseño",
      links_tab: "Enlaces",
      integrations_tab: "Integr.",
      social_tab: "Social",
      bio: "Bio",
      theme_color: "Color del Tema",
      background_color: "Color de Fondo",
      text_color: "Color del Texto",
      button_type: "Estilo de Botones",
      font_family: "Fuente",
      profile_image: "Foto de Perfil",
      banner_image: "Banner",
      show_booking: "Mostrar botón de reserva",
      show_catalog: "Mostrar botón del catálogo",
      show_coupons: "Mostrar cupones",
      show_products: "Mostrar productos",
      show_social: "Mostrar iconos de redes sociales",
      show_categories: "Mostrar categorías",
      save_settings: "Guardar Configuración",
      settings_saved: "¡Configuración guardada!",
      loading: "Cargando...",
      link_types: {
        link: "Enlace Externo",
        product: "Producto",
        video: "Video",
        image: "Imagen",
        whatsapp_group: "Grupo WhatsApp",
      },
      button_styles: {
        filled: "Relleno",
        outline: "Contorno",
        soft: "Suave",
        glass: "Cristal",
      },
      // Additional linktree keys
      appearance: "Apariencia",
      display_name_label: "Nombre de Visualización",
      display_name_design_placeholder: "Nombre de tu página",
      font_label: "Fuente",
      bio_label: "Bio / Descripción",
      bio_placeholder: "Una breve descripción sobre ti o tu empresa",
      main_color: "Color Principal",
      background: "Fondo",
      text: "Texto",
      button_style_label: "Estilo Botones",
      profile_photo: "Foto de Perfil",
      banner: "Banner",
      save_design: "Guardar Diseño",
      catalog_integrations: "Integraciones con Catálogo",
      catalog_settings: "Configuración del catálogo en Bio Page",
      products_count: "Productos destacados",
      social_networks: "Redes Sociales",
      social_desc: "Agrega enlaces a tus redes sociales",
      instagram: "Instagram",
      facebook: "Facebook",
      whatsapp: "WhatsApp",
      tiktok: "TikTok",
      youtube: "YouTube",
      save_social: "Guardar Redes Sociales",
      edit_link_title: "Editar Enlace",
      save_changes: "Guardar Cambios",
      catalog_button: "Botón Catálogo",
      catalog_button_desc: "Mostrar botón de acceso al catálogo",
      featured_products: "Productos Destacados",
      featured_products_desc: "Mostrar productos del catálogo",
      featured_products_count: "Cantidad de productos destacados",
      products_count_label: "{{count}} productos",
      booking_button: "Botón Agendar",
      booking_button_desc: "Enlace para agendamiento online",
      active_coupons: "Cupones Activos",
      active_coupons_desc: "Mostrar cupones de descuento",
      show_categories_label: "Mostrar Categorías",
      show_categories_desc: "Organizar enlaces por categoría",
      save_integrations: "Guardar Integraciones",
      show_social_icons: "Mostrar iconos de redes sociales",
      show_social_icons_desc: "Mostrar iconos clicables en el perfil",
      title_required: "Título *",
      title_placeholder: "Ej: Nuestro Instagram",
      url_label: "URL",
      url_placeholder: "https://",
      product_label: "Producto del Catálogo",
      select_product: "Selecciona un producto",
      video_url_label: "URL del Video (YouTube/Vimeo)",
      video_url_placeholder: "https://youtube.com/...",
      groups_available: "{{count}} grupo(s) disponible(s)",
      no_groups_configured: "Ningún grupo configurado",
      groups_rotate_hint: "El enlace será rotado automáticamente a grupos con cupos",
      configure_groups_hint: "Configura grupos en Grupos WhatsApp primero",
      description_optional: "Descripción (opcional)",
      description_placeholder: "Breve descripción del enlace",
      thumbnail: "Miniatura",
      thumbnail_placeholder: "Imagen del enlace",
      category_label: "Categoría",
      category_placeholder: "Ej: Redes Sociales",
      icon_label: "Ícono (emoji)",
      add_link_btn: "Agregar Enlace",
      no_links_yet: "Ningún enlace agregado aún",
      click_to_start: "Haz clic en \"Nuevo Enlace\" para comenzar",
      no_url: "Sin URL",
      active: "Activo",
      inactive: "Inactivo",
    },

    quick_create: {
      create: "Crear",
      new_customer: "Nuevo Cliente",
      new_sale: "Nueva Venta",
      new_appointment: "Nueva Cita",
      new_task: "Nueva Tarea",
      new_proposal: "Nueva Propuesta",
    },

    goals: {
      title: "Metas y KPIs",
      description: "Define y sigue tus metas de negocio",
      new_goal: "Nueva Meta",
      create_goal: "Crear Meta",
      goal_name: "Nombre de la meta",
      goal_name_placeholder: "Ej: Facturación de Enero",
      type: "Tipo",
      target_value: "Valor objetivo",
      start: "Inicio",
      end: "Fin",
      search_goals: "Buscar metas...",
      filter_type: "Filtrar tipo",
      all_types: "Todos los tipos",
      active_goals: "Metas Activas",
      history: "Historial de Metas",
      progress: "Progreso",
      current: "Actual",
      target: "Meta",
      no_goals_found: "Ninguna meta encontrada",
      try_filters: "Intenta cambiar los filtros",
      start_creating: "Comienza definiendo tus primeras metas",
      completed: "Completada",
      not_achieved: "No alcanzada",
      types: { revenue: "Facturación", sales_count: "Cant. Ventas", new_customers: "Nuevos Clientes", appointments: "Citas", products_sold: "Productos Vendidos", services_sold: "Servicios Vendidos" },
    },

    lead_funnel: {
      analytics_title: "Analytics del Embudo IA",
      analytics_description: "Métricas y rendimiento del embudo de calificación",
      total_leads: "Total de Leads",
      hot_leads: "Leads Calientes",
      conversion_rate: "Tasa Conversión",
      scheduling_rate: "Tasa Agendamiento",
      avg_score: "Score Promedio de Leads",
      hot: "Calientes",
      warm: "Tibios",
      cold: "Fríos",
      funnel_by_stage: "Embudo por Etapa",
      classification: "Clasificación de Leads",
      recent_leads: "Leads Recientes",
      no_name: "Sin nombre",
      no_leads_yet: "Ningún lead capturado aún.",
      stages: { new: "Nuevos", qualifying: "Calificando", qualified: "Calificados", scheduled: "Agendados", converted: "Convertidos", lost: "Perdido" },
      sources: { manual: "Manual", form: "Formulario", crm_customer: "Cliente CRM", import: "Importación" },
    },

    checklist: {
      title: "Checklists",
      description: "Gestiona rutinas e inspecciones",
      new_checklist: "Nuevo Checklist",
      create_checklist: "Crear Checklist",
      name_placeholder: "Ej: Checklist de Apertura",
      description_optional: "Descripción (opcional)",
      describe_checklist: "Describe el checklist...",
      checklist_items: "Ítems del Checklist",
      item_description: "Descripción del ítem",
      templates: "Plantillas",
      history: "Historial",
      search_checklist: "Buscar checklist...",
      all_types: "Todos los tipos",
      no_checklists_created: "Ningún checklist creado",
      no_checklists_found: "Ningún checklist encontrado",
      create_first: "Crea tu primer checklist para comenzar",
      try_filters: "Intenta ajustar los filtros",
      items: "ítems",
      execute: "Ejecutar",
      no_executions: "Ninguna ejecución registrada",
      by: "por",
      complete: "Completo",
      partial: "Parcial",
      type_here: "Escribe...",
      finish_checklist: "Finalizar Checklist",
      types: { opening: "Apertura", closing: "Cierre", cleaning: "Limpieza", inspection: "Inspección", epi: "EPP", general: "General" },
      field_types: { boolean: "Sí/No", text: "Texto", number: "Número" },
    },

    gym: {
      title: "Gimnasio",
      description: "Gestión de alumnos, entrenamientos y evolución física",
      students: "Alumnos",
      plans: "Planes",
      workouts: "Entrenamientos",
      workout: "Entrenamiento",
      evolution: "Evolución",
      nutrition: "Dieta",
      active_plans: "Planes Activos",
      expiring: "Por vencer",
      search_student: "Buscar alumno...",
      no_students_found: "Ningún alumno encontrado",
      no_phone: "Sin teléfono",
      new_plan: "Nuevo Plan",
      create_plan: "Crear Plan",
      create_plan_for_student: "Crear Plan para Alumno",
      student: "Alumno",
      plan: "Plan",
      price: "Precio",
      duration_months: "Duración",
      start_date: "Fecha de Inicio",
      new_workout: "Nuevo Entrenamiento",
      create_workout: "Crear Entrenamiento",
      workout_title: "Título del Entrenamiento",
      workout_description: "Descripción",
      level: "Nivel",
      exercises: "Ejercicios",
      add_exercise: "Agregar",
      no_workouts_found: "Ningún entrenamiento encontrado",
      no_workouts_desc: "Crea entrenamientos personalizados o usa plantillas",
      fill_required_fields: "Complete todos los campos obligatorios.",
      fill_workout_title: "Complete el título del entrenamiento.",
      select_student_first: "Seleccione un alumno primero.",
      error_creating_workout: "Error al crear entrenamiento:",
      error_generating_suggestion: "Error al generar sugerencia de entrenamiento.",
      suggestion_generated: "Sugerencia generada.",
      levels: { beginner: "Principiante", intermediate: "Intermedio", advanced: "Avanzado" },
      plan_types: { monthly: "Mensual", quarterly: "Trimestral", semiannual: "Semestral", annual: "Anual" },
      ai_prompts: { beginner: "Crea un plan de entrenamiento para principiante con 3 días por semana, incluyendo ejercicios básicos con series y repeticiones.", intermediate: "Crea un plan de entrenamiento intermedio con 4 días por semana, enfocado en hipertrofia.", advanced: "Crea un plan de entrenamiento avanzado con 5 días por semana, técnicas avanzadas de intensidad." },
    },

    delivery: {
      title: "Delivery Propio",
      description: "Gestiona entregas, zonas y repartidores",
      orders: "Pedidos",
      zones: "Zonas",
      drivers: "Repartidores",
      settings: "Configuración",
      total_orders: "Total de Pedidos",
      pending: "Pendientes",
      out_for_delivery: "En Entrega",
      delivered: "Entregados",
      cancelled: "Cancelados",
      deliveries_today: "Entregas por Repartidor (Hoy)",
      delivery_orders: "Pedidos de Delivery",
      no_orders_found: "Ningún pedido encontrado",
      order_code: "Código",
      customer: "Cliente",
      address: "Dirección",
      driver: "Repartidor",
      fee: "Tarifa",
      assign: "Asignar",
      previous: "Anterior",
      next: "Siguiente",
      page_of: "Página {{current}} de {{total}}",
      orders_found: "{{count}} pedido(s) encontrado(s)",
      new_zone: "Nueva Zona",
      create_zone: "Crear Zona",
      zone_name: "Nombre de la Zona",
      neighborhoods: "Barrios",
      delivery_time: "Tiempo de Entrega",
      minutes: "minutos",
      no_zones: "Ninguna zona registrada",
      no_zones_desc: "Crea zonas de entrega para definir tarifas por región",
      new_driver: "Nuevo Repartidor",
      edit_driver: "Editar Repartidor",
      create_driver: "Registrar Repartidor",
      driver_name: "Nombre del Repartidor",
      vehicle_type: "Tipo de Vehículo",
      available: "Disponible",
      unavailable: "No disponible",
      no_drivers: "Ningún repartidor registrado",
      no_drivers_desc: "Registra repartidores para tu equipo de delivery",
      save_settings: "Guardar Configuración",
      saving: "Guardando...",
      settings_saved: "¡Configuración guardada!",
      whatsapp_notifications: "Notificaciones WhatsApp",
      whatsapp_notifications_desc: "Enviar actualizaciones de estado automáticamente",
      status: { pending: "Pendiente", preparing: "Preparando", ready: "Listo", out_for_delivery: "En Camino", delivered: "Entregado", cancelled: "Cancelado", rejected: "Rechazado" },
      vehicle_types: { moto: "Moto", bicicleta: "Bicicleta", carro: "Carro", a_pe: "A pie" },
    },

    // Commissions
    commissions: {
      title: "Comisiones",
      subtitle: "Gestiona reglas y pagos de comisiones",
      new_rule: "Nueva Regla",
      active_rules: "Reglas Activas",
      pending: "Pendiente",
      paid_period: "Pagado (período)",
      total_period: "Total (período)",
      tabs: { summary: "Resumen por Profesional", entries: "Movimientos", rules: "Reglas" },
      start_date: "Fecha Inicio",
      end_date: "Fecha Fin",
      no_commissions_period: "Sin comisiones en el período",
      entries_count: "{{count}} movimientos",
      pending_label: "pendiente",
      paid_label: "pagado",
      search_professional: "Buscar por profesional...",
      professional: "Profesional",
      pay_selected: "Pagar Seleccionados ({{count}})",
      no_entries: "No se encontraron movimientos",
      paid: "Pagado",
      no_rules: "Sin reglas registradas",
      all_professionals: "Todos los profesionales",
      new_commission_rule: "Nueva Regla de Comisión",
      service: "Servicio",
      all_services: "Todos los servicios",
      percentage: "Porcentaje (%)",
      fixed_value: "Valor Fijo",
      create_rule: "Crear Regla",
    },

    // Communication
    communication: {
      chat: "Chat",
      create_channel: "Crear Canal",
      channel_name: "Nombre del canal",
      channel_name_placeholder: "Ej: #general, #ventas",
      members_access: "Miembros con acceso",
      members_access_desc: "Deja vacío para que todos los miembros del equipo tengan acceso",
      member: "Miembro",
      channels: "Canales",
      no_channels: "Sin canales",
      team: "Equipo",
      my_status: "Mi estado",
      status: { online: "En línea", away: "Ausente", busy: "Ocupado", offline: "Desconectado" },
      roles: { owner: "Propietario", admin: "Admin", staff: "Colaborador" },
      rename: "Renombrar",
      manage_members: "Gestionar miembros",
      delete_channel: "Eliminar canal",
      select_channel: "Selecciona un canal",
      loading_messages: "Cargando mensajes...",
      no_messages: "Sin mensajes aún.",
      be_first: "¡Sé el primero en escribir!",
      user: "Usuario",
      mention: "Mencionar",
      message_placeholder: "Escribe tu mensaje... Usa @ para mencionar",
      rename_channel: "Renombrar Canal",
      new_name: "Nuevo nombre",
      delete_channel_confirm: "¿Estás seguro de que quieres eliminar este canal? Todos los mensajes se perderán.",
      manage_channel_members: "Gestionar Miembros del Canal",
      manage_members_desc: "Selecciona quién puede ver y enviar mensajes en este canal. Deja vacío para que todos tengan acceso.",
      all_have_access: "Todos los miembros del equipo tendrán acceso",
      members_selected: "{{count}} miembro(s) seleccionado(s)",
    },

    // Webhooks
    webhooks: {
      title: "Webhooks",
      subtitle: "Configura URLs para recibir notificaciones de eventos del sistema",
      new_webhook: "Nuevo Webhook",
      create_webhook: "Crear Webhook",
      create_description: "Configura una URL para recibir notificaciones cuando ocurran eventos",
      url: "URL del Webhook",
      events: "Eventos",
      configured: "Webhooks Configurados",
      manage_description: "Gestiona los webhooks que recibirán notificaciones de eventos",
      no_webhooks: "Sin webhooks configurados",
      fill_url_events: "Completa la URL y selecciona al menos un evento",
      created: "Webhook creado con éxito",
      logs: "Logs del Webhook",
      logs_description: "Últimas 50 llamadas realizadas a este webhook",
      no_logs: "Sin logs encontrados",
      no_response: "Sin respuesta",
      delete_title: "Eliminar Webhook",
      delete_confirm: "¿Estás seguro de que deseas eliminar este webhook? Esta acción no se puede deshacer.",
    },

    // Packages
    packages: {
      title: "Paquetes y Sesiones",
      subtitle: "Gestiona paquetes de servicios y créditos",
      sell_package: "Vender Paquete",
      new_package: "Nuevo Paquete",
      package_types: "Tipos de Paquetes",
      total_sold: "Total Vendidos",
      active_packages: "Paquetes Activos",
      completed: "Completados",
      sessions: "sesiones",
      remaining: "restantes",
      consume: "Consumir",
      renew: "Renovar",
      package_sales: "Ventas de Paquetes",
      search_placeholder: "Buscar por cliente o paquete...",
      all: "Todos",
      active: "Activos",
      cancelled: "Cancelados",
      no_packages_sold: "No se encontraron paquetes vendidos",
      no_package_types: "No hay tipos de paquetes registrados",
      new_package_type: "Nuevo Tipo de Paquete",
      name: "Nombre",
      name_placeholder: "Ej: Paquete 10 Sesiones",
      qty_sessions: "Cant. Sesiones",
      price: "Precio",
      linked_service: "Servicio Vinculado",
      optional: "Opcional",
      description: "Descripción",
      description_placeholder: "Descripción opcional...",
      create: "Crear Paquete",
      select_customer: "Seleccionar Cliente",
      select_package: "Seleccionar Paquete",
      expiration: "Vencimiento",
      sell: "Vender Paquete",
      renew_package: "Renovar Paquete",
      additional_sessions: "Sesiones Adicionales",
      new_expiration: "Nuevo Vencimiento",
      confirm_renew: "Renovar Paquete",
    },

    // Quotes
    quotes: {
      title: "Presupuestos",
      subtitle: "Crea y envía propuestas comerciales a tus clientes",
      description: "Crea y envía propuestas comerciales a tus clientes",
      new_quote: "Nuevo Presupuesto",
      edit_quote: "Editar Presupuesto",
      create_quote: "Crear Presupuesto",
      save_changes: "Guardar Cambios",
      total: "Total",
      status: {
        draft: "Borrador",
        sent: "Enviado",
        approved: "Aprobado",
        rejected: "Rechazado",
      },
      draft: "Borrador",
      sent: "Enviado",
      approved: "Aprobado",
      rejected: "Rechazado",
      total_approved: "Total Aprobado",
      approved_value: "Valor Aprobado",
      customer: "Cliente",
      select_customer: "Seleccionar cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Ningún cliente encontrado.",
      customer_placeholder: "Seleccionar cliente",
      title_label: "Título",
      title_placeholder: "Ej: Propuesta de servicios",
      description_optional: "Descripción (opcional)",
      refine_with_ai: "Refinar con IA",
      proposal_details: "Detalles de la propuesta...",
      description_placeholder: "Detalles de la propuesta...",
      items: "Ítems",
      item: "Ítem",
      add: "Agregar",
      item_name: "Nombre del ítem",
      quantity_short: "Cant",
      qty: "Cant",
      price: "Precio",
      unit_price: "Precio Unit.",
      subtotal: "Subtotal",
      discount: "Descuento",
      search_placeholder: "Buscar por título o cliente...",
      all_status: "Todos los estados",
      no_quotes: "Sin presupuestos",
      start_creating: "Comienza creando tu primer presupuesto",
      create_first: "Crea tu primer presupuesto",
      send: "Enviar",
      copy_link: "Copiar Link",
      view: "Ver",
      print: "Imprimir",
      edit: "Editar",
      delete: "Eliminar",
      share: "Compartir",
      convert_contract: "Convertir a Contrato",
      generate_contract: "Generar Contrato",
      create_project: "Crear Proyecto",
      approve: "Aprobar",
      reject: "Rechazar",
      delete_quote: "Eliminar Presupuesto",
      delete_confirmation: "¿Estás seguro de que deseas eliminar este presupuesto? Esta acción no se puede deshacer.",
      delete_confirm: "¿Estás seguro de que deseas eliminar este presupuesto?",
      share_quote: "Compartir Presupuesto",
      share_message: "Hola {{name}}, aquí está el link de tu presupuesto:",
      quote_details: "Detalles del Presupuesto",
      created_at: "Creado en",
      responded_at: "Respondido en",
      generated_at: "Generado en",
      add_title_or_description_first: "Agrega un título o descripción primero",
      proposal_refined: "¡Propuesta refinada con IA!",
      could_not_refine: "No se pudo refinar la propuesta",
      refine_error: "Error al refinar propuesta",
      link_copied: "¡Link copiado!",
      sent_success: "¡Presupuesto enviado!",
      approved_success: "¡Presupuesto aprobado!",
      rejected_success: "¡Presupuesto rechazado!",
      converted_success: "¡Contrato creado!",
      project_created: "¡Proyecto creado!",
      deleted: "¡Presupuesto eliminado!",
    },

    // NPS
    nps: {
      title: "Encuesta NPS",
      subtitle: "Acompaña la satisfacción de tus clientes",
      score: "Score NPS",
      excellent: "Excelente",
      very_good: "Muy bueno",
      reasonable: "Razonable",
      needs_improvement: "Necesita mejorar",
      promoters: "Promotores",
      passives: "Pasivos",
      detractors: "Detractores",
      scores_9_10: "Notas 9-10",
      scores_7_8: "Notas 7-8",
      scores_0_6: "Notas 0-6",
      responses_tab: "Respuestas",
      config_tab: "Configuración",
      search_placeholder: "Buscar por cliente o comentario...",
      category: "Categoría",
      all: "Todas",
      promoters_filter: "Promotores (9-10)",
      passives_filter: "Pasivos (7-8)",
      detractors_filter: "Detractores (0-6)",
      pending_filter: "No respondidos",
      loading: "Cargando...",
      no_surveys: "Ninguna encuesta encontrada",
      surveys_auto_sent: "Las encuestas se enviarán automáticamente después de las citas",
      try_filters: "Intenta ajustar los filtros",
      customer: "Cliente",
      responded_at: "Respondido en",
      sent_at: "Enviado en",
      comment: "Comentario",
      not_responded: "No respondido",
      promoter: "Promotor",
      passive: "Pasivo",
      detractor: "Detractor",
      auto_send: "Envío Automático",
      send_after_appointment: "Enviar después de cita",
      send_after_description: "Envía encuesta automáticamente después de citas completadas",
      wait_time: "Tiempo de espera (minutos)",
      wait_time_description: "Tiempo después de la cita para enviar la encuesta",
      survey_questions: "Preguntas de la Encuesta",
      survey_questions_description: "Personaliza las preguntas que verán tus clientes",
      main_question: "Pregunta Principal (Nota)",
      main_question_placeholder: "En una escala de 0 a 10, ¿qué tan probable es que recomiendes nuestro servicio a un amigo o colega?",
      main_question_description: "Pregunta que aparece junto con la escala de 0-10",
      comment_question: "Pregunta de Comentario",
      comment_question_description: "Pregunta opcional para recoger feedback en texto",
      comment_prompt_default: "¿Qué motivó tu nota?",
      preview: "Vista Previa de la Encuesta",
      your_comment: "Tu comentario (opcional)",
      save_config: "Guardar Configuración",
      saving: "Guardando...",
      config_saved: "¡Configuración guardada!",
    },

    // Satisfaction
    satisfaction: {
      title: "Encuestas de Satisfacción",
      subtitle: "Envía encuestas y acompaña la satisfacción de los clientes",
      new_survey: "Nueva Encuesta",
      share_survey: "Compartir Encuesta",
      send_survey: "Enviar Encuesta de Satisfacción",
      select_customer: "Seleccionar cliente",
      create_survey: "Crear Encuesta",
      survey_link: "Link de la encuesta:",
      copy_link: "Copiar Link",
      whatsapp: "WhatsApp",
      email: "Email",
      done: "Listo",
      avg_score: "Promedio General",
      nps_score: "Score NPS",
      total_responses: "Total Respuestas",
      churn_risk: "Riesgo de Abandono",
      search_placeholder: "Buscar encuestas...",
      sent_surveys: "Encuestas Enviadas",
      loading: "Cargando...",
      no_surveys: "Ninguna encuesta encontrada",
      customer: "Cliente",
      score: "Nota",
      sentiment: "Sentimiento",
      feedback: "Feedback",
      date: "Fecha",
      status: "Estado",
      actions: "Acciones",
      responded: "Respondida",
      pending: "Pendiente",
      positive: "positivo",
      negative: "negativo",
      neutral: "neutro",
      link_copied: "¡Link copiado!",
      sent_whatsapp: "¡Encuesta enviada por WhatsApp!",
      no_phone: "Cliente no tiene teléfono registrado",
      no_instance: "Ninguna instancia WhatsApp conectada",
      error_whatsapp: "Error al enviar WhatsApp",
    },

    // Referrals
    referrals: {
      title: "Programa de Referidos",
      subtitle: "Gestiona tu programa de referidos de clientes",
      total_referrals: "Total Referidos",
      converted: "Convertidos",
      pending: "Pendientes",
      conversion_rate: "Tasa de Conversión",
      program_tab: "Programa",
      referrals_tab: "Referidos",
      status: "Estado",
      active: "Activo",
      inactive: "Inactivo",
      paused: "Pausado",
      referred_reward: "Recompensa Referido",
      referrer_reward: "Recompensa Referidor",
      discount: "descuento",
      no_program: "Ningún programa activo",
      no_program_description: "Configura un programa de referidos para tus clientes",
      received_referrals: "Referidos Recibidos",
      no_referrals: "Ningún referido recibido aún",
      referred: "Referido",
      date: "Fecha",
      status_pending: "Pendiente",
      status_converted: "Convertido",
      status_rewarded: "Recompensado",
      status_expired: "Expirado",
    },

    // Reactivation
    reactivation: {
      title: "Reactivación de Clientes",
      subtitle: "Reconquista clientes inactivos",
      inactive_30: "+30 días inactivos",
      inactive_60: "+60 días inactivos",
      inactive_90: "+90 días inactivos",
      potential_revenue: "Ingreso Potencial",
      search_placeholder: "Buscar cliente...",
      period: "Período",
      days_30: "+30 días",
      days_60: "+60 días",
      days_90: "+90 días",
      days_180: "+180 días",
      email: "Email",
      whatsapp: "WhatsApp",
      inactive_customers: "Clientes Inactivos",
      select_all: "Seleccionar todos",
      deselect_all: "Deseleccionar todos",
      no_inactive: "No se encontraron clientes inactivos",
      great_news: "¡Genial! Tus clientes están activos.",
      days: "días",
      last_visit: "Última:",
      never_visited: "Nunca visitó",
      visits: "visitas",
      select_at_least_one: "Selecciona al menos un cliente",
      no_whatsapp_instance: "Ninguna instancia WhatsApp conectada",
      messages_sent: "mensajes enviados",
      failures: "fallas",
      emails_sent: "emails enviados",
    },

    // Automations
    automations: {
      title: "Automatizaciones",
      subtitle: "Configura acciones automáticas basadas en el comportamiento del cliente",
      new_automation: "Nueva Automatización",
      create_automation: "Crear Nueva Automatización",
      automation_name: "Nombre de la automatización *",
      automation_name_placeholder: "Ej: Reactivación de clientes inactivos",
      after_create_hint: "Después de crear, serás dirigido al editor visual donde podrás configurar disparadores, condiciones y acciones.",
      creating: "Creando...",
      create_and_configure: "Crear y Configurar",
      search_placeholder: "Buscar automatización...",
      status_all: "Todos",
      status_active: "Activas",
      status_inactive: "Inactivas",
      loading: "Cargando...",
      no_automation_configured: "Ninguna automatización configurada",
      no_automation_found: "Ninguna automatización encontrada",
      create_automations_hint: "Crea automatizaciones para interactuar con tus clientes automáticamente",
      try_filters: "Intenta ajustar los filtros",
      create_first: "Crear primera automatización",
      active: "Activa",
      inactive: "Inactiva",
      delete_title: "Eliminar Automatización",
      delete_description: "¿Estás seguro de que deseas eliminar esta automatización? Esta acción no se puede deshacer.",
      tags_count: "etiqueta(s)",
    },

    // Tags Management
    tags_management: {
      title: "Tags / Etiquetas",
      subtitle: "Organiza y categoriza tus clientes con etiquetas personalizadas",
      new_tag: "Nueva Etiqueta",
      edit_tag: "Editar Etiqueta",
      tag_name: "Nombre de la Etiqueta *",
      tag_name_placeholder: "Ej: VIP, Premium, Nuevo cliente...",
      color: "Color",
      description_placeholder: "Descripción opcional...",
      update: "Actualizar",
      create: "Crear Etiqueta",
      name_required: "El nombre es obligatorio",
      tag_updated: "¡Etiqueta actualizada!",
      tag_created: "¡Etiqueta creada!",
      tag_deleted: "¡Etiqueta eliminada!",
      total_tags: "Total de Etiquetas",
      customers_with_tags: "Clientes con Etiquetas",
      tags_per_customer: "Etiquetas por Cliente (promedio)",
      search_placeholder: "Buscar etiquetas...",
      loading: "Cargando...",
      no_tag_created: "Ninguna etiqueta creada",
      no_tag_found: "Ninguna etiqueta encontrada",
      create_tags_hint: "Crea etiquetas para organizar y categorizar tus clientes",
      try_search: "Intenta ajustar la búsqueda",
      create_first: "Crear primera etiqueta",
      customers: "cliente(s)",
      delete_title: "Eliminar Etiqueta",
      delete_description: "¿Estás seguro de que deseas eliminar esta etiqueta? Será eliminada de todos los clientes.",
      colors: {
        blue: "Azul",
        green: "Verde",
        red: "Rojo",
        yellow: "Amarillo",
        purple: "Morado",
        pink: "Rosa",
        orange: "Naranja",
        teal: "Turquesa",
      },
    },

    // Real Estate Module
    real_estate: {
      title: "Inmobiliaria",
      subtitle: "Gestión completa de propiedades, contratos y pagos",
      description: "Gestión de propiedades y alquileres",
      properties: "Propiedades",
      inspections: "Inspecciones",
      templates: "Plantillas",
      new_property: "Nueva Propiedad",
      register_property: "Registrar Propiedad",
      search_placeholder: "Buscar propiedades...",
      search_property: "Buscar propiedad...",
      filter_status: "Filtrar Estado",
      all_status: "Todos",
      show_inactive: "Mostrar inactivos",
      no_property_found: "Ninguna propiedad encontrada",
      no_client_found: "Ningún cliente encontrado",
      add_photos: "Agregar Fotos",
      property_types: {
        apartment: "Apartamento",
        house: "Casa",
        commercial: "Comercial",
        land: "Terreno",
      },
      status: {
        available: "Disponible",
        rented: "Alquilado",
        sold: "Vendido",
        maintenance: "Mantenimiento",
        inactive: "Inactivos",
      },
      stats: {
        total: "Total",
        available: "Disponibles",
        rented: "Alquilados",
        monthly_income: "Ingresos/mes",
        pending: "Pendientes",
      },
      tabs: {
        properties: "Propiedades",
        templates: "Plantillas",
        inspections: "Inspecciones",
        owners: "Propietarios",
        tenants: "Inquilinos",
        payments: "Pagos",
        maintenance: "Mantenimiento",
      },
      fields: {
        title: "Título",
        address: "Dirección",
        type: "Tipo",
        bedrooms: "Habitaciones",
        bathrooms: "Baños",
        parking: "Garaje",
        area: "Área (m²)",
        rent_value: "Valor Alquiler",
        sale_value: "Valor Venta",
        description: "Descripción",
        owner: "Propietario",
        photo_gallery: "Galería de Fotos",
      },
      placeholders: {
        title: "Ej: Apartamento Centro",
        address: "Calle, número, barrio",
        description: "Descripción de la propiedad...",
        select_owner: "Seleccione el propietario...",
        search_client: "Buscar cliente...",
        select_tenant: "Seleccione el inquilino...",
        room_name: "Nombre de la habitación",
        add_item: "Agregar ítem...",
        select_property: "Seleccione la propiedad...",
        search_property: "Buscar propiedad...",
      },
      payment_types: {
        rent: "Alquiler",
        deposit: "Depósito",
        condominium: "Condominio",
        water: "Agua",
        electricity: "Electricidad",
        iptu: "Impuesto Predial",
        other: "Otro",
      },
    },

    // E-commerce
    ecommerce: {
      title: "E-commerce",
      subtitle: "Gestiona pedidos y pagos de tu tienda",
      orders: "Pedidos",
      payments: "Pagos",
      products: "Productos",
      settings: "Configuraciones",
      total_orders: "Total Pedidos",
      pending: "Pendientes",
      revenue: "Ingresos",
      avg_ticket: "Ticket Promedio",
      search_placeholder: "Buscar por cliente, email o ID...",
      filter_status: "Filtrar estado",
      all_statuses: "Todos los estados",
      no_orders: "Ningún pedido encontrado",
      orders_appear: "Los pedidos aparecerán aquí cuando los clientes compren en tu tienda.",
      order_details: "Detalles del Pedido",
      tracking_code: "Código de Seguimiento",
      tracking_placeholder: "Ingrese el código de seguimiento",
      mark_shipped: "Marcar como Enviado",
      customer: "Cliente",
      shipping_address: "Dirección de Envío",
      items: "Artículos",
      qty: "Cant",
      subtotal: "Subtotal",
      shipping: "Envío",
      discount: "Descuento",
      total: "Total",
      status_updated: "Estado actualizado",
      products_info_title: "Gestiona tus productos",
      products_info_desc: "Los productos registrados en Inventario aparecen aquí. Activa los que deseas vender online.",
      go_to_products: "Ir a Inventario y Productos →",
      search_products: "Buscar productos...",
      no_products_found: "Ningún producto encontrado",
      no_products: "Ningún producto registrado",
      try_different_search: "Intenta una búsqueda diferente",
      add_products_first: "Registra productos en Inventario para venderlos aquí.",
      add_product: "Agregar Producto",
      low_stock: "Stock bajo",
      active: "En tienda",
      inactive: "Oculto",
      stock: "Stock",
      sell_online: "Vender online",
      product_enabled: "Producto habilitado",
      product_disabled: "Producto deshabilitado",
      product_enabled_desc: "El producto ahora está visible en la tienda",
      product_disabled_desc: "El producto ha sido ocultado de la tienda",
      update_error: "Error al actualizar producto",
      store_url: "Enlace de la Tienda",
      store_url_description: "Comparte este enlace para que tus clientes accedan a tu tienda",
      configure_slug: "Configura el slug de tu empresa en las configuraciones para tener un enlace personalizado.",
      url_copied: "Enlace de la tienda copiado al portapapeles",
      shipping_settings: "Configuraciones de Envío",
      default_shipping: "Tarifa de envío predeterminada",
      shipping_fee_note: "Deja 0 para envío gratis",
      min_order_value: "Pedido mínimo",
      min_order_note: "Valor mínimo para completar pedido",
      free_shipping_above: "Envío gratis arriba de",
      free_shipping_note: "Ofrece envío gratis para pedidos superiores a un valor",
      notification_settings: "Notificaciones",
      whatsapp_notifications: "Notificar por WhatsApp",
      whatsapp_note: "Recibe alertas de nuevos pedidos en WhatsApp",
      email_notifications: "Notificar por Email",
      email_note: "Recibe alertas de nuevos pedidos por email",
      customer_notifications: "Notificar clientes",
      customer_note: "Envía actualizaciones de estado a clientes",
      store_settings: "Configuraciones de la Tienda",
      store_enabled: "Tienda activa",
      store_enabled_note: "Desactiva para pausar las ventas temporalmente",
      show_prices: "Mostrar precios",
      show_prices_note: "Mostrar precios de productos en la tienda",
      show_stock: "Mostrar stock",
      show_stock_note: "Mostrar cantidad disponible",
      theme_color: "Color del tema",
      banner_image: "Imagen del banner",
      upload_banner: "Subir banner",
      remove_banner: "Quitar banner",
      configure_payments: "Configurar Pagos",
      stripe_not_configured: "Pagos no configurados",
      stripe_description: "Configura tu cuenta para recibir pagos directamente. Las ventas van directo a tu cuenta bancaria.",
      how_it_works: "Cómo funciona",
      step_1_title: "Conecta tu cuenta",
      step_1_desc: "Haz clic en el botón abajo para crear tu cuenta en Stripe. Es gratis.",
      step_2_title: "Completa el registro",
      step_2_desc: "Llena tus datos bancarios y documentos para verificación.",
      step_3_title: "¡Comienza a vender!",
      step_3_desc: "Después de la aprobación, puedes recibir por tarjeta, PIX y más.",
      benefit_security: "Seguro",
      benefit_security_desc: "Protección contra fraudes",
      benefit_transfers: "Automático",
      benefit_transfers_desc: "Transferencias automáticas",
      benefit_methods: "Múltiples métodos",
      benefit_methods_desc: "Tarjeta, PIX, boleto",
      connect_stripe: "Conectar con Stripe",
      stripe_note: "Stripe cobra ~3.5% + R$0.40 por transacción. Sin mensualidades.",
      stripe_account: "Cuenta Stripe",
      account_status: "Estado de la Cuenta",
      status_active: "Activo",
      status_pending: "Pendiente",
      receive_payments: "Recibir Pagos",
      receive_payouts: "Recibir Retiros",
      enabled: "Habilitado",
      incomplete_setup: "Configuración incompleta",
      incomplete_description: "Tu cuenta necesita información adicional para comenzar a recibir pagos.",
      complete_registration: "Completar Registro",
      ready_to_sell: "¡Listo para vender!",
      ready_description: "Tu cuenta está activa. Los pagos serán transferidos automáticamente.",
      manage_stripe: "Gestionar en Stripe",
      status: {
        pending: "Pendiente",
        paid: "Pagado",
        processing: "Procesando",
        shipped: "Enviado",
        delivered: "Entregado",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
      },
      stripe_connect: {
        title: "Stripe Connect",
        description: "Conecta tu cuenta Stripe para recibir pagos directamente en tu cuenta bancaria.",
        setup: "Configurar Stripe Connect",
        setting_up: "Configurando...",
        status_pending: "Pendiente",
        status_active: "Activo",
        payments_enabled: "Pagos habilitados",
        payouts_enabled: "Retiros habilitados",
        go_to_dashboard: "Ir al Dashboard de Stripe",
      },
    },
    
    // Security & Privacy
    security: {
      title: "Seguridad y Privacidad",
      description: "Protección de datos y configuraciones de seguridad",
      access_token: "Token de Acceso",
      access_token_description: "Token único para acceso seguro al pedido",
      token_generated: "Token generado automáticamente",
      token_secure: "Acceso seguro vía token",
      track_order: "Seguir Pedido",
      order_link: "Enlace del Pedido",
      copy_link: "Copiar Enlace",
      link_copied: "¡Enlace copiado!",
      send_to_customer: "Enviar al Cliente",
      data_protection: "Protección de Datos",
      sensitive_data: "Datos Sensibles",
      restricted_access: "Acceso Restringido",
      only_owners_admins: "Solo propietarios y administradores",
      staff_can_view_own: "Empleado puede ver sus propios datos",
      salary_hidden: "Salario oculto para otros",
      bank_data_protected: "Datos bancarios protegidos",
      access_levels: "Niveles de Acceso",
      owner: "Propietario",
      admin: "Administrador",
      manager: "Gerente",
      staff_role: "Empleado",
      full_access: "Acceso completo",
      limited_access: "Acceso limitado",
      view_only: "Solo visualización",
      lgpd_compliance: "Conformidad LGPD",
      hipaa_compliance: "Conformidad HIPAA",
      data_encrypted: "Datos cifrados",
      audit_logs: "Registros de auditoría",
      two_factor_auth: "Autenticación de dos factores",
      session_timeout: "Tiempo de espera de sesión",
    },
    
    // Reviews Module
    reviews: {
      title: "Reseñas",
      subtitle: "Gestiona reseñas y reputación del negocio",
      average_rating: "Calificación Promedio",
      total: "Total de Reseñas",
      pending: "Pendientes",
      public: "Públicas",
      distribution: "Distribución de Calificaciones",
      all_reviews: "Todas las Reseñas",
      search: "Buscar reseñas...",
      all: "Todas",
      approved: "Aprobadas",
      approve: "Aprobar",
      reject: "Rechazar",
      respond: "Responder",
      hide: "Ocultar",
      show: "Hacer Pública",
      no_reviews: "No se encontraron reseñas",
      no_comment: "Sin comentario",
      your_response: "Tu respuesta:",
      write_response: "Escribe tu respuesta...",
      send_response: "Enviar Respuesta",
      // Display settings
      settings: "Configuración",
      display_settings: "Configuración de Visualización",
      display_settings_desc: "Elige dónde se mostrarán tus reseñas aprobadas",
      locations: "Ubicaciones",
      widget: "Widget",
      minisite: "Mini-sitio",
      minisite_desc: "Mostrar reseñas en la página principal del mini-sitio",
      catalog: "Catálogo",
      catalog_desc: "Mostrar reseñas en el catálogo de productos",
      store: "Tienda",
      store_desc: "Mostrar reseñas en la tienda online",
      max_displayed: "Máximo de reseñas mostradas",
      show_stats: "Mostrar estadísticas",
      show_stats_desc: "Mostrar calificación promedio y total de reseñas",
      enable_widget: "Activar Widget",
      enable_widget_desc: "Permite incrustar reseñas en sitios externos",
      js_widget: "Widget JavaScript",
      iframe_widget: "Widget iFrame",
      copy: "Copiar",
      preview: "Vista Previa",
      preview_hint: "Las reseñas aparecerán aquí cuando incrustes el widget en tu sitio externo.",
      code_copied: "¡Código {{type}} copiado!",
      // Public display
      public_title: "Lo que dicen nuestros clientes",
      reviews_count: "reseñas",
      anonymous: "Cliente",
      business_response: "Respuesta del negocio:",
    },
  },
};
